<template>
  <div class="export-video-dialog dialog" @keydown.stop v-show="!hidden">
    <el-dialog
      :visible="visible"
      v-bind="dialogProps"
      @close="close()"
      @open="onOpenDialog()"
    >
      <template v-if="judgeBox">
        <div class="dialog__header" slot="title">
          设置导出信息
          <div
            class="dialog__close"
            @click="close()"
            style="width: 20px; height: 20px; background-repeat: no-repeat"
          >
            <!-- <i class="icon-popup-close"></i> -->
          </div>
        </div>

        <div
          class="dialog__body form"
          :class="{
            painterSubmit: isPainterSubmit,
          }"
          style="padding-top: 90px"
        >
          <div>
            <template v-if="TOOL.optimized === 'Horizontal'">
              <div class="form__cover-preview md20">
                <template v-if="isShowSwapCoverBtn && coverForbiddenState.url">
                  <img :src="$handleAssetsUrl(coverForbiddenState.url)" alt="">
                </template>
                <img v-else v-show="previewCoverUrl" :src="previewCoverUrl" alt />

                <drr
                  v-bind="getMovingHandler()"
                  ref="drrHorizontal"
                  @change="sendInfoToEngine"
                  @dragstop="onDragStop"
                  @resizestop="onResizeStop"
                  @rotatestop="onResizeStop"
                  @select="onDrrActive"
                >
                  <div
                    class="watermark"
                    v-show="watermarkFile.url && watermarkFile.isShow"
                    :style="css.watermark"
                  >
                    <img
                      :src="watermarkFile.url"
                      style="position: absolute; right: 0; bottom: 0"
                      :style="css.watermarkImage"
                      alt
                      @load="onMyWatermarkLoaded($event)"
                    />
                  </div>
                </drr>
                <div
                  class="watermark watermark--default"
                  v-show="formData.watermark.defaults"
                >
                  <i
                    class="icon-default-watermark-h"
                    style="width: 100%; height: 100%"
                  ></i>
                </div>

                <div class="cover-forbidden-state" v-show="isShowSwapCoverBtn">
                  <div
                    v-if="(coverForbiddenState.state === 2)"
                    class="loading"
                  >
                    <p>封面审核中</p>
                  </div>
                  <div
                    v-if="(coverForbiddenState.state === 0)"
                    class="cover-failed"
                  >
                    <p>封面审核未通过，请<a @click="getCoverFile()" href="javascript:;">重新上传</a></p>
                    <div class="oper-btn" :class="['oper-btn-'+TOOL.optimized]">
                      <button
                        class="button--primary"
                        @click="showCensoredInfo"
                      >查看详情</button>
                      <button
                        class="button--default"
                        @click="refreshForbiddenState"
                      >刷新状态</button>
                    </div>
                  </div>
                </div>

                <label
                  for="exportDialogInputFile"
                  v-show="cover && cover.blob && isShowSwapCoverBtn"
                  class="btn"
                  >替换</label
                >
              </div>

              <div class="form-field md20">
                <div class="form-field__content">
                  <div style="padding-left: 1em">
                    是否作为本地视频MP4的封面：
                  </div>
                  <div class="cover-option" @click="onClickCoverOption">
                    <el-switch
                      v-model="isFirstFrameCover"
                      :disabled="firstFrameCoverDisabled"
                    ></el-switch>
                    <!-- <div
                      v-if="UserLevel === 0"
                      :class="[UserLevel === 0 ? 'commonVip' : 'companyVip']"
                    ></div> -->
                  </div>
                </div>
              </div>
              <div class="form__cover-picker form-field md20">
                <div class="form-field__title" style="min-width: 2em">
                  <span style="position: absolute; left: 0; top: -350px"
                    >封面</span
                  >
                </div>
                <div class="form-field__content">
                  <div class="cover-picker">
                    <ul>
                      <li
                        v-for="item in [
                          ...formData.snaps,
                          ...[{}, {}, {}],
                        ].slice(0, 3)"
                        :key="item.url"
                        @click="activatePreview({ url: (item || {}).url })"
                      >
                        <img
                          :class="{
                            'is-selected': item && item.url === previewCoverUrl,
                          }"
                          :src="item && item.url"
                          alt
                        />
                      </li>
                      <!-- <li @click="activatePreview({url: (formData.snaps[0] || {}).url})"
                        :class="{'is-selected': formData.snaps[0].url === previewCoverUrl}"
                      >
                        <img :src="formData.snaps[0] && formData.snaps[0].url" alt="">
                      </li>
                      <li @click="activatePreview({url: (formData.snaps[1] || {}).url})">
                        <img :src="formData.snaps[1] && formData.snaps[1].url" alt="">
                      </li>
                      <li @click="activatePreview({url: (formData.snaps[2] || {}).url})">
                        <img :src="formData.snaps[2] && formData.snaps[2].url" alt="">
                      </li>-->
                      <li
                        class="is-upload"
                        v-show="cover.url"
                        @click="activatePreview({ url: cover.url })"
                      >
                        <img
                          :class="{
                            'is-selected':
                              cover && cover.url === previewCoverUrl,
                          }"
                          :src="cover.url"
                          alt
                        />
                      </li>
                      <li
                        style="position: relative"
                        class="is-add"
                        @click="getCoverFile()"
                        v-show="!cover.url"
                        v-analysis="ANALYSIS.customCover"
                      >
                        <i
                          :class="{
                            'my-icon-add': !cover.url,
                            'el-icon-edit': cover.url,
                          }"
                        ></i>
                        <input
                          id="exportDialogInputFile"
                          ref="fileInputRef"
                          type="file"
                          accept="image/jpg, image/jpeg, image/png, image/gif, .svg"
                          name="files[]"
                          style="display: none"
                          @change="onChangeCoverFile($event)"
                        />
                        <div
                          v-if="UserEquity.noCustomCover"
                          class="mask-a"
                          style="
                            width: 110%;
                            height: 110%;
                            position: absolute;
                            top: -3px;
                            left: -3px;
                            cursor: not-allowed;
                          "
                        >
                          <!-- <div
                            style="position: absolute; right: -12px; top: -6px"
                            :class="[
                              UserLevel === 0 ? 'commonVip' : 'companyVip',
                            ]"
                          ></div> -->
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-field md40">
                <div style="margin-left: -200px; color: #c2c2d9">
                  （如果需要上传封面，建议大小不超过500K）
                </div>
              </div>
            </template>
            <template v-if="TOOL.optimized === 'Vertical'">
              <div
                class="form__cover-preview md20"
                style="width: 155px; transform: translate(-102%, 0)"
              >
                <template v-if="isShowSwapCoverBtn && coverForbiddenState.url">
                  <img :src="$handleAssetsUrl(coverForbiddenState.url)" alt="">
                </template>
                <img v-else v-show="previewCoverUrl" :src="previewCoverUrl" alt />

                <drr
                  v-bind="getMovingHandler('v')"
                  ref="drrVertical"
                  @change="sendInfoToEngine"
                  @dragstop="onDragStop"
                  @resizestop="onResizeStop"
                  @rotatestop="onResizeStop"
                  @select="onDrrActive"
                >
                  <div
                    class="watermark"
                    :style="css.watermark"
                    v-show="watermarkFile.url && watermarkFile.isShow"
                  >
                    <img
                      :src="watermarkFile.url"
                      style="position: 'absolute'; right: 0; bottom: 0"
                      :style="css.watermarkImage"
                      alt
                      @load="onMyWatermarkLoaded($event)"
                    />
                  </div>
                </drr>
                <div
                  class="watermark watermark--default vertical-editor"
                  v-show="formData.watermark.defaults"
                >
                  <i
                    class="icon-default-watermark-v vertical-editor"
                    style="width: 100%; height: 100%"
                  ></i>
                </div>

                <div class="cover-forbidden-state" v-show="isShowSwapCoverBtn">
                  <div
                    v-if="(coverForbiddenState.state === 2)"
                    class="loading"
                  >
                    <p>封面审核中</p>
                  </div>
                  <div
                    v-if="(coverForbiddenState.state === 0)"
                    class="cover-failed"
                  >
                    <p>封面审核未通过，请<a @click="getCoverFile()" href="javascript:;">重新上传</a></p>
                    <div class="oper-btn" :class="['oper-btn-'+TOOL.optimized]">
                      <button
                        class="button--primary"
                        @click="showCensoredInfo"
                      >查看详情</button>
                      <button
                        class="button--default"
                        @click="refreshForbiddenState"
                      >刷新状态</button>
                    </div>
                  </div>
                </div>

                <label
                  for="exportDialogInputFile"
                  v-show="cover && cover.blob && isShowSwapCoverBtn"
                  class="btn"
                  >替换</label
                >
              </div>
              <div class="form-field md20">
                <div class="form-field__content">
                  <div style="padding-left: 1em">
                    请选择封面，并设置是否合成至视频第一帧：
                  </div>
                  <div class="cover-option" @click="onClickCoverOption">
                    <el-switch
                      v-model="isFirstFrameCover"
                      :disabled="firstFrameCoverDisabled"
                    ></el-switch>
                    <!-- <div
                      v-if="UserLevel === 0"
                      :class="[UserLevel === 0 ? 'commonVip' : 'companyVip']"
                    ></div> -->
                  </div>
                </div>
              </div>
              <div class="form__cover-picker form-field md20">
                <div class="form-field__title" style="min-width: 2em">
                  <span style="position: absolute; left: 0; top: -350px"
                    >封面</span
                  >
                </div>
                <div class="form-field__content">
                  <div class="cover-picker">
                    <ul>
                      <li
                        v-for="item in [
                          ...formData.snaps,
                          ...[{}, {}, {}],
                        ].slice(0, 3)"
                        :key="item.url"
                        @click="activatePreview({ url: (item || {}).url })"
                        style="width: 31px"
                      >
                        <img
                          :class="{
                            'is-selected': item && item.url === previewCoverUrl,
                          }"
                          :src="item && item.url"
                          alt
                        />
                      </li>
                      <li
                        class="is-upload"
                        v-show="cover.url"
                        style="width: 31px"
                        @click="activatePreview({ url: cover.url })"
                      >
                        <img
                          :class="{
                            'is-selected':
                              cover && cover.url === previewCoverUrl,
                          }"
                          :src="cover.url"
                          alt
                        />
                      </li>
                      <li
                        class="is-add"
                        style="width: 40px"
                        @click="getCoverFile()"
                        v-show="!cover.url"
                        v-analysis="ANALYSIS.customCover"
                      >
                        <i
                          :class="{
                            'my-icon-add': !cover.url,
                            'el-icon-edit': cover.url,
                          }"
                        ></i>
                        <input
                          id="exportDialogInputFile"
                          ref="fileInputRef"
                          type="file"
                          accept="image/jpg, image/jpeg, image/png, image/gif, .svg"
                          name="files[]"
                          style="display: none"
                          @change="onChangeCoverFile($event)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="form-field md40">
                <div style="margin-left: -200px; color: #c2c2d9">
                  （如果需要上传封面，建议大小不超过500K）
                </div>
              </div>
            </template>
          </div>

          <painterSubmit
            :judgeBox="judgeBox"
            v-model="formData"
            :descLength="descLength"
            v-on:validateText="validateText"
            v-on:onMouseEnterTag="onMouseEnterTag"
            v-on:onMouseLeaveTag="onMouseLeaveTag"
            v-on:removeTag="removeTag"
            v-on:onBlurTagInput="onBlurTagInput"
            v-on:pushTag="pushTag"
            v-on:valiateTagInput="valiateTagInput"
            v-on:formDataFS="formDataFS"
            ref="painterSubmitRef"
          />

          <div
            v-if="
              this.TopnavMsg.transferData && !this.TopnavMsg.transferData.type
            "
            class="form__title form-field md20"
          >
            <div class="form-field__title is-required">标题</div>
            <div class="form-field__content">
              <div class="form-field__input">
                <input
                  type="text"
                  :placeholder="formData.title.placeholder"
                  v-model="formData.title.value"
                  :maxlength="formData.title.maxlength"
                  @change="validateText({ name: 'title' })"
                  ref="titleInputRef"
                />
                <span class="form-field__tip">
                  {{ formData.title.value.length }}/{{
                    formData.title.maxlength
                  }}
                </span>
              </div>
              <div
                class="form-field__valid-tip"
                v-show="formData.title.validFail"
              >
                {{ formData.title.validTip }}
              </div>
            </div>
          </div>
          <div
            v-if="
              this.TopnavMsg.transferData && !this.TopnavMsg.transferData.type
            "
            class="form__tags form-field md20"
          >
            <div
              class="form-field__title"
              :class="{ 'is-required': formData.tags.isRequired }"
            >
              标签
            </div>
            <div class="form-field__content">
              <div
                class="form-field__tag"
                v-for="(tag, i) in formData.tags.items"
                :key="i"
                @mouseenter="onMouseEnterTag(tag, i)"
                @mouseleave="onMouseLeaveTag(tag, i)"
              >
                <span>{{ tag.text }}</span>
                <i
                  v-show="tag.hover"
                  @click="removeTag(i)"
                  class="remove el-icon-circle-close"
                ></i>
              </div>
              <div class="form-field__input" v-show="formData.tags.isShowInput">
                <!-- <el-tooltip effect="dark" :content="formData.tags.placeholder" placement="top"> -->
                <input
                  type="text"
                  :maxlength="formData.tags.maxlength"
                  :placeholder="getTagsPlaceholder(tagsItemsMax)"
                  v-model="formData.tags.value"
                  :disabled="formData.tags.disabled"
                  @keyup.enter="onBlurTagInput()"
                  @change="pushTag()"
                  @blur="onBlurTagInput()"
                  @input="valiateTagInput()"
                  ref="tagsInputRef"
                />
                <!-- </el-tooltip> -->
              </div>
              <div
                class="form-field__valid-tip"
                v-show="!formData.tags.forceHidden && formData.tags.validFail"
              >
                {{ formData.tags.validTip }}
              </div>
            </div>
          </div>
          <div
            v-if="
              this.TopnavMsg.transferData && !this.TopnavMsg.transferData.type
            "
            class="form__desc form-field md40"
          >
            <div
              class="form-field__title is-top"
              :class="{ 'is-required': formData.tags.isRequired }"
            >
              简介
            </div>
            <div class="form-field__content">
              <div class="form-field__textarea">
                <textarea
                  :placeholder="formData.desc.placeholder"
                  v-model="formData.desc.value"
                  :maxlength="formData.desc.maxlength"
                  @change="validateText({ name: 'desc' })"
                  ref="descInputRef"
                ></textarea>
                <span class="form-field__tip"
                  >{{ descLength }}/{{ formData.desc.maxlength }}</span
                >
              </div>
              <div
                class="form-field__valid-tip"
                v-show="formData.desc.validFail"
              >
                {{ formData.desc.validTip }}
              </div>
            </div>
          </div>
          <div
            v-if="
              this.TopnavMsg.transferData && !this.TopnavMsg.transferData.type
            "
            class="form__radios form-field md22"
          >
            <div class="form-field__title is-required">水印</div>
            <div class="form-field__content">
              <div class="radios">
                <ul>
                  <li v-for="(item, key) in formData.watermark" :key="key">
                    <div
                      class="radio"
                      @click="
                        onClickRadio({
                          items: formData.watermark,
                          key: key,
                          info: watermarkInfo,
                          name: 'watermark',
                        });
                        reportRadio(watermarkInfo[key]);
                      "
                    >
                      <div
                        class="radio__shape"
                        :class="{ 'is-active': item }"
                      ></div>
                      <div class="radio__label">
                        {{ watermarkInfo[key].text }}
                      </div>
                      <span
                        v-if="watermarkInfo[key].isVip"
                        :class="[
                          // (UserLevel === 0 || UserMsg.tmpLevelType != null) &&
                          // watermarkInfo[key].key === 'none'
                          //   ? 'commonVip'
                          //   : 'commonVip',
                            getWatermarkBadgeClassName(watermarkInfo[key].key)
                        ]"
                      ></span>
                      <span
                        v-if="key === 'custom'"
                        class="small-btn ml button--small"
                        @click.stop="
                          onUploadWatermark();
                          reportRadio(watermarkInfo[key]);
                        "
                        >上传</span
                      >
                      <label for="imageWatermark" style="display: none"></label>
                    </div>
                    <div
                      class="radio__tip"
                      v-show="
                        (item ||
                          (UserMsg.tmpLevelType && UserLevelType === 2)) &&
                        watermarkInfo[key].tip
                      "
                    >
                      {{ watermarkInfo[key].tip }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            v-if="
              this.TopnavMsg.transferData && !this.TopnavMsg.transferData.type
            "
            class="form__radios form-field"
          >
            <div class="form-field__title is-required">清晰度</div>
            <div class="form-field__content">
              <div class="radios">
                <ul>
                  <li v-for="(item, key) in formData.pixel" :key="key">
                    <div
                      class="radio"
                      @click="
                        onClickRadio({
                          items: formData.pixel,
                          key: key,
                          info: pixelInfo,
                          name: 'pixel',
                        });
                        reportRadio(pixelInfo[key]);
                      "
                    >
                      <div
                        class="radio__shape"
                        :class="{ 'is-active': item }"
                      ></div>
                      <div class="radio__label">{{ pixelInfo[key].text }}</div>
                      <span
                        v-if="pixelInfo[key].isVip"
                        :class="[
                          UserLevel === 0 && pixelInfo[key].key === '720p'
                            ? 'pro-logo'
                            : 'pro-logo',
                        ]"
                      ></span>
                    </div>
                    <div class="radio__tip" v-show="item && pixelInfo[key].tip">
                      {{ pixelInfo[key].tip }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <competition
            v-if="signedUpCompetitions.length > 0"
            :lists="signedUpCompetitions"
            :choosedCompetition="choosedCompetition"
            @chooseAction="chooseActivityAction"
          ></competition> -->
        </div>

        <painterBtn
          :btn-disabled="templateInvalid"
          :judgeBox="judgeBox"
          :formData="formData"
          :painterVideoUrl="painterVideoUrl"
          :unlock="unlock"
          v-on:submit="submit"
          v-on:close="close"
          v-on:openPage="saveDraftAndJump"
        />

        <div
          v-show="
            this.TopnavMsg.transferData && !this.TopnavMsg.transferData.type
          "
          class="dialog__footer"
          slot="footer"
        >
          <!-- <div class="submit button--primary" @click="submit()">
            确定
          </div>-->
          <member-footer
            :btn-disabled="templateInvalid"
            :exportInfo="exportInfo"
            :checkedPixel="checkedPixel"
            @submit="submit"
            ref="memberFooter"
          ></member-footer>
          <div
            v-if="typeof initialChecked === 'boolean'"
            style="padding-top: 22px"
          >
            <checkbox-share
              ref="checkboxShare"
              :initialChecked="initialChecked"
            ></checkbox-share>
          </div>
          <div style="padding-top: 1em; text-align: center">
            注意:平台可
            <span class="text-blue">商用</span
            >范围內的素材、字体、音乐等资源,仅针对会员授权;如用作
            <span class="text-blue">商用</span>途径,请先购买平台会员。
          </div>
        </div>
      </template>
      <template v-else>
        <div class="dialog-container" unselectable="on">
          <!-- <qr
            style="position: absolute; bottom: 27px; right: 17px;"
            :text="['扫码领取会员', '导出更无忧']"
            :id="'1514100483881570304'"
          ></qr> -->
          <div class="dialog-close" @click="close">
            <i class="iconfont iconguanbianniu2"></i>
          </div>
          <div class="dialog-header">
            <div v-if="IsDraftShareShown" class="part-title">
              <div class="title-main">确认效果</div>
              <div class="title-detail">
                不消耗功能权益次数，复制链接，可与他人一起确认视频效果。（请使用电脑查看）
              </div>
            </div>
            <dialogSharePart v-if="IsDraftShareShown"></dialogSharePart>
          </div>
          <div
            class="dialog-body"
            :class="{ v: TOOL.optimized === 'Vertical' }"
          >
            <div class="part-title">
              <div class="title-main">导出视频</div>
              <div class="title-detail">
                <partTitleTip></partTitleTip>
              </div>
            </div>
            <div class="part-content">
              <div class="cover-col">
                <div
                  class="cover-col-content"
                  :class="{ v: TOOL.optimized === 'Vertical' }"
                >
                  <div
                    class="form__cover-preview"
                    :class="{ v: TOOL.optimized === 'Vertical' }"
                  >
                    <div class="tag">封面</div>
                    <template v-if="isShowSwapCoverBtn && coverForbiddenState.url">
                      <img :src="$handleAssetsUrl(coverForbiddenState.url)" alt="">
                    </template>
                    <img v-else v-show="previewCoverUrl" :src="previewCoverUrl" alt />

                    <drr
                      v-bind="
                        getMovingHandler(
                          TOOL.optimized === 'Vertical' ? 'v' : ''
                        )
                      "
                      :ref="
                        TOOL.optimized === 'Vertical'
                          ? 'drrVertical'
                          : 'drrHorizontal'
                      "
                      @change="sendInfoToEngine"
                      @dragstop="onDragStop"
                      @resizestop="onResizeStop"
                      @rotatestop="onResizeStop"
                      @select="onDrrActive"
                    >
                      <div
                        class="watermark"
                        v-show="watermarkFile.url && watermarkFile.isShow"
                        :style="css.watermark"
                      >
                        <img
                          :src="watermarkFile.url"
                          style="position: absolute; right: 0; bottom: 0"
                          :style="css.watermarkImage"
                          alt
                          @load="onMyWatermarkLoaded($event)"
                        />
                      </div>
                    </drr>
                    <div
                      class="watermark watermark--default small"
                      :class="{
                        'vertical-editor': TOOL.optimized === 'Vertical',
                      }"
                      v-show="formData.watermark.defaults"
                    >
                      <i
                        :class="{
                          'vertical-editor': TOOL.optimized === 'Vertical',
                          'icon-default-watermark-h':
                            TOOL.optimized !== 'Vertical',
                          'icon-default-watermark-v':
                            TOOL.optimized === 'Vertical',
                        }"
                        style="width: 100%; height: 100%"
                      ></i>
                    </div>

                    <div class="cover-forbidden-state" v-show="isShowSwapCoverBtn">
                      <div
                        v-if="(coverForbiddenState.state === 2)"
                        class="loading"
                      >
                        <p>封面审核中</p>
                      </div>
                      <div
                        v-if="(coverForbiddenState.state === 0)"
                        class="cover-failed"
                      >
                        <p>封面审核未通过，请<a @click="getCoverFile()" href="javascript:;">重新上传</a></p>
                        <div class="oper-btn" :class="['oper-btn-'+TOOL.optimized]">
                          <button
                            class="button--primary"
                            @click="showCensoredInfo"
                          >查看详情</button>
                          <button
                            class="button--default"
                            @click="refreshForbiddenState"
                          >刷新状态</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="cover-picker-field v"
                    v-if="TOOL.optimized === 'Vertical'"
                  >
                    <div
                      class="v-picker-item"
                      :class="{
                        'is-selected': item && item.url === previewCoverUrl,
                      }"
                      v-for="item in [...formData.snaps, ...[{}, {}, {}]].slice(
                        0,
                        3
                      )"
                      :key="item.url"
                      @click="activatePreview({ url: (item || {}).url })"
                    >
                      <img :src="item && item.url" alt />
                    </div>
                    <div
                      class="is-upload v-picker-item"
                      :class="{
                        'is-selected': cover && cover.url === previewCoverUrl,
                      }"
                      v-show="cover.url"
                      @click="activatePreview({ url: cover.url })"
                    >
                      <img :src="cover.url" alt />
                    </div>
                    <div
                      class="v-picker-item is-add"
                      style="position: relative"
                      @click="getCoverFile()"
                      v-show="!cover.url"
                    >
                      <i class="iconfont icona-lujing13427"></i>
                      <input
                        id="exportDialogInputFile"
                        ref="fileInputRef"
                        type="file"
                        accept="image/jpg, image/jpeg, image/png, image/gif, .svg"
                        name="files[]"
                        style="display: none"
                        @change="onChangeCoverFile($event)"
                      />
                      <div
                        v-if="UserEquity.noCustomCover"
                        class="mask-a"
                        style="
                          width: 110%;
                          height: 110%;
                          position: absolute;
                          top: -3px;
                          left: -3px;
                          cursor: not-allowed;
                        "
                      >
                        <!-- <div
                          style="position: absolute; right: -12px; top: -6px"
                          :class="[
                            UserLevel === 0 ? 'commonVip' : 'companyVip',
                          ]"
                        ></div> -->
                      </div>
                    </div>
                  </div>
                  <div v-else class="form__cover-picker form-field">
                    <div class="form-field__content">
                      <div class="cover-picker">
                        <ul>
                          <li
                            class="picker-item"
                            v-for="item in [
                              ...formData.snaps,
                              ...[{}, {}, {}],
                            ].slice(0, 3)"
                            :key="item.url"
                            @click="activatePreview({ url: (item || {}).url })"
                          >
                            <img
                              :class="{
                                'is-selected':
                                  item && item.url === previewCoverUrl,
                              }"
                              :src="item && item.url"
                              alt
                            />
                          </li>
                          <li
                            class="is-upload picker-item"
                            v-show="cover.url"
                            @click="activatePreview({ url: cover.url })"
                          >
                            <img
                              :class="{
                                'is-selected':
                                  cover && cover.url === previewCoverUrl,
                              }"
                              :src="cover.url"
                              alt
                            />
                            <div class="export-dialogInput-file">
                              <label
                                for="exportDialogInputFile"
                                v-show="cover && cover.blob"
                                class="btn"
                                >替换</label
                              >
                            </div>
                          </li>
                          <li
                            style="position: relative"
                            class="is-add picker-item"
                            @click="getCoverFile()"
                            v-show="!cover.url"
                            v-analysis="ANALYSIS.customCover"
                          >
                            <i class="iconfont icona-lujing13427"></i>
                            <input
                              id="exportDialogInputFile"
                              ref="fileInputRef"
                              type="file"
                              accept="image/jpg, image/jpeg, image/png, image/gif, .svg"
                              name="files[]"
                              style="display: none"
                              @change="onChangeCoverFile($event)"
                            />
                            <div
                              v-if="UserEquity.noCustomCover"
                              class="mask-a"
                              style="
                                width: 110%;
                                height: 110%;
                                position: absolute;
                                top: -3px;
                                left: -3px;
                                cursor: not-allowed;
                              "
                            >
                              <!-- <div
                                style="
                                  position: absolute;
                                  right: -12px;
                                  top: -6px;
                                "
                                :class="[
                                  UserLevel === 0 ? 'commonVip' : 'companyVip',
                                ]"
                              ></div> -->
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-field cover-size-tip">
                  <div>如果需要上传封面，建议大小不超过500K</div>
                </div>

                <div class="form-field">
                  <div class="form-field__content">
                    <div>作为本地视频MP4的封面：</div>
                    <div class="cover-option" @click="onClickCoverOption">
                      <!-- <el-switch
                        v-model="isFirstFrameCover"
                        :disabled="firstFrameCoverDisabled"
                        :width="26"
                      ></el-switch> -->
                      <i
                        class="iconfont"
                        :class="[
                          isFirstFrameCover ? 'icona-170 active' : 'icona-180',
                        ]"
                        @click="isFirstFrameCover = !isFirstFrameCover"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="info-col">
                <div
                  v-if="
                    this.TopnavMsg.transferData &&
                    !this.TopnavMsg.transferData.type
                  "
                  class="form__title form-field"
                >
                  <div class="field-title">标题</div>
                  <div class="form-field__content">
                    <div class="form-field__input">
                      <input
                        type="text"
                        :placeholder="formData.title.placeholder"
                        v-model="formData.title.value"
                        :maxlength="formData.title.maxlength"
                        @change="validateText({ name: 'title' })"
                        ref="titleInputRef"
                      />
                      <span class="form-field__tip">
                        {{ formData.title.value.length }}/{{
                          formData.title.maxlength
                        }}
                      </span>
                    </div>
                    <div
                      class="form-field__valid-tip"
                      v-show="formData.title.validFail"
                    >
                      {{ formData.title.validTip }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    this.TopnavMsg.transferData &&
                    !this.TopnavMsg.transferData.type
                  "
                  class="form__radios form-field"
                >
                  <div class="field-title">水印</div>
                  <div class="form-field__content">
                    <div class="radios">
                      <ul>
                        <li
                          v-for="(item, key) in formData.watermark"
                          :key="key"
                        >
                          <div
                            class="radio"
                            @click="
                              onClickRadio({
                                items: formData.watermark,
                                key: key,
                                info: watermarkInfo,
                                name: 'watermark',
                              });
                              reportRadio(watermarkInfo[key]);
                            "
                          >
                            <div
                              class="radio__shape"
                              :class="{ 'is-active': item }"
                            ></div>
                            <div class="radio__label">
                              {{ watermarkInfo[key].text }}
                            </div>
                            <span
                              v-if="key === 'custom'"
                              class="upload-btn"
                              @click.stop="
                                onUploadWatermark();
                                reportRadio(watermarkInfo[key]);
                              "
                            >上传</span>
                            <span
                              v-if="watermarkInfo[key].isVip"
                              :class="[
                                // (UserLevel === 0 ||
                                //   UserMsg.tmpLevelType != null ||
                                //   isSolo) &&
                                // watermarkInfo[key].key === 'none'
                                //   ? 'commonVip'
                                //   : 'commonVip',
                                  getWatermarkBadgeClassName(watermarkInfo[key].key)
                              ]"
                            ></span>
                            <label
                              for="imageWatermark"
                              style="display: none"
                            ></label>
                          </div>
                          <!-- <div
                            class="radio__tip"
                            v-show="
                              (item || (UserMsg.tmpLevelType && UserLevelType === 2)) &&
                              watermarkInfo[key].tip
                            "
                          >{{ watermarkInfo[key].tip }}</div> -->
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    this.TopnavMsg.transferData &&
                    !this.TopnavMsg.transferData.type
                  "
                  class="form__radios form-field"
                >
                  <div class="field-title">清晰度</div>
                  <div class="form-field__content">
                    <div class="radios">
                      <ul>
                        <li v-for="(item, key) in formData.pixel" :key="key">
                          <div
                            class="radio"
                            @click="
                              onClickRadio({
                                items: formData.pixel,
                                key: key,
                                info: pixelInfo,
                                name: 'pixel',
                              });
                              reportRadio(pixelInfo[key]);
                            "
                          >
                            <div
                              class="radio__shape"
                              :class="{ 'is-active': item }"
                            ></div>
                            <div class="radio__label">
                              {{ pixelInfo[key].text }}
                            </div>
                            <span
                              v-if="pixelInfo[key].isVip"
                              :class="[
                                (UserLevel === 0 || isSolo) &&
                                pixelInfo[key].key === '720p'
                                  ? 'pro-logo'
                                  : 'pro-logo',
                              ]"
                            ></span>
                          </div>
                          <!-- <div
                            class="radio__tip"
                            v-show="item && pixelInfo[key].tip"
                          >{{ pixelInfo[key].tip }}</div> -->
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div v-if="false" class="new-content">
                  <a
                  class="link-text"
                  href="/contest/customizable?activityId=53"
                  target="_blank">点击前往来画AIGC短视频大赛</a>，参赛赢千元丰厚奖品
                </div>

                <competition
                  v-if="signedUpCompetitions.length > 0"
                  :lists="signedUpCompetitions"
                  :choosedCompetition="choosedCompetition"
                  @chooseAction="chooseActivityAction"
                ></competition>

                <powerTip
                  ref="powerTip"
                  :watermark="formData.watermark"
                  :pixel="formData.pixel"
                ></powerTip>
              </div>
            </div>
          </div>
          <div class="dialog-footer">
            <div class="sumbit-btn-wrapper">
              <member-footer
                :is-activate-cover="isShowSwapCoverBtn"
                :btn-disabled="templateInvalid"
                :exportInfo="exportInfo"
                :checkedPixel="checkedPixel"
                @submit="submit"
                ref="memberFooter"
              ></member-footer>
              <div
                v-if="typeof initialChecked === 'boolean'"
                style="padding-top: 6px"
              >
                <checkbox-share
                  ref="checkboxShare"
                  :initialChecked="initialChecked"
                ></checkbox-share>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-dialog>
    <company-info v-model="isShowCompanyInfo"></company-info>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import domtoimage from "../../plugins/dom-to-image";
import setBlobImageSize from "../../plugins/setBlobImageSize";
import memberFooter from "./exportDialog/memberFooter";
import checkboxShare from "./exportDialog/checkboxShare";
import painterSubmit from "./exportDialog/painterSubmit";
import painterBtn from "./exportDialog/painterBtn";
import snap from "../mixins/snap";
import analysis from "@/components/mixins/analysis/exportDialog";
import drr from "@/plugins/drr";
import map from "lodash/map";
import companyInfo from "./exportDialog/companyInfo.vue";
import competition from "./exportDialog/competition.vue";
import dialogSharePart from "./exportDialog/dialogSharePart";
import powerTip from "./exportDialog/powerTip";
import partTitleTip from "./exportDialog/partTitleTip";
import qr from '../widgets/qr.vue';

const getMixLen = function (str) {
  if (str == null) return 0;
  if (typeof str !== "string") {
    str += "";
  }
  return str.replace(/[^\x00-\xff]/g, "01").length;
};

function unhandleAssetsUrl(url) {
  return url ? url.replace(/https:\/\/resources.laihua.com(\/)?/, "") : "";
}

const PREVIEW_WIDTH = 493;
const PREVIEW_HEIGHT = 278;
const PREVIEW_HEIGHT_SMALL = 165;

export default {
  components: {
    memberFooter,
    checkboxShare,
    drr,
    painterSubmit,
    painterBtn,
    companyInfo,
    competition,
    dialogSharePart,
    powerTip,
    partTitleTip,
    qr
  },
  mixins: [snap, analysis],
  props: {
    visible: Boolean,
  },
  data() {
    return {
      // 表单视图相关
      formData: {
        // cover: '', // 自定义封面
        snaps: [], // 截图封面
        title: {
          value: "我的作品",
          placeholder: "好的标题可吸引更多的观众来看",
          maxlength: 32,
          validTip: "请填写标题",
          validate() {
            let v = this.value;
            return v && v.length > 0;
          },
          validFail: false,
          isRequired: true,
        },
        tags: {
          value: "",
          placeholder: "填写标签便于检索，最多不超过5个，点击Enter隔开多个标签",
          disabled: false,
          items: [],
          isShowInput: true,
          validTip: "请填写标签，每个标签最多8个汉字或16个字母",
          validate() {
            // let notEmpty = this.value && this.value.length > 0;
            let correctTextLen = getMixLen(this.value) <= 16;
            // let correctTextLen = this.value.length <= 16;
            return correctTextLen;
          },
          validFail: false,
          forceHidden: false,
          isRequired: false,
          // maxlength: 16,
          limitLength: 16,
        },
        desc: {
          value: "做短视频像做PPT一样简单？快挪步到“来画动画”一探究竟吧！",
          placeholder: "简介可展示关于视频的更多背景信息或内容哦",
          maxlength: 64,
          validTip: "请填写简介",
          validate() {
            // let v = this.value;
            // return v && v.length > 0;
            return true;
          },
          validFail: false,
          isRequired: false,
        },
        watermark: {
          defaults: true,
          none: false,
          custom: false,
        },
        pixel: {
          "480p": true,
          "720p": false,
          "1080p": false,
        },
        labelStyle: [], // 发布style标签
        categories: [], // 发布style分类的标签
        payType: 0, // 0、1，0：免费，1：收费
        price: "", // 金额
      },
      watermarkInfo: {
        defaults: {
          text: "默认水印",
          isVip: false,
          value: "default",
          tip: "",
          key: "defaults",
        },
        none: {
          text: "无水印",
          isVip: true,
          value: "",
          tip: "您共有t次无水印的权益，目前还剩余r次。",
          key: "none",
        },
        custom: {
          text: "自定义水印",
          isVip: true,
          value: "custom.png",
          tip: "您共有t次自定水印的权益，目前还剩余r次。",
          key: "custom",
        },
      },
      watermarkSizes: {
        defaults: {},
        none: {},
        custom: {},
      },
      pixelInfo: {
        "480p": {
          text: "标清480P",
          isVip: false,
          value: "480",
          tip: "",
          key: "480p",
        },
        "720p": {
          text: "高清720P",
          isVip: true,
          value: "720",
          tip: "",
          key: "720p",
        },
        "1080p": {
          text: "超清1080P",
          isVip: true,
          value: "1080",
          tip: "",
          key: "1080p",
        },
      },
      checkedWatermark: null,
      checkedPixel: {},

      // 封面相关
      uploadThumbnail: "", // 自定义封面的data url，用来传递到封面截取组件
      previewCoverUrl: "", // 当前预览的封面url
      previewCoverBlob: null, // 当前预览的封面blob
      paramCoverUrl: "", // 上传到图片服务器后，创建的文件url
      screenParam: "", // 对应导出视频接口字段 screen，用于平台页面展示的封面

      // 自定义水印
      watermarkFile: {
        blob: null,
        url: "",
        isShow: false,
      },

      // 其他
      messageInstance: null, // 数据是否提交成功的 toast
      isShowSwapCoverBtn: false, // 是否显示更换封面按钮
      isLock: false,
      saveWorksPromise: null,
      toolOptimized: "",
      hidden: true,
      css: {
        watermark: {
          position: "relative",
          width: "100%",
          height: "100%",
        },
        watermarkImage: {
          // position: 'absolute',
          // top: 0,
          // right: 0,
          // bottom: 0,
          // left: 0,
          // margin: 'auto',
          width: "100%",
          height: "100%",
        },
      },
      judgeBox: false,
      painterVideoUrl: "",
      combinationType: "text",
      exportInfo: {
        limit: null,
        num: null,
      },
      videoResponse: {},
      initialChecked: null,
      isShowCompanyInfo: false,
      hasCompanyInfo: false,
      isFirstFrameCover: true,
      choosedCompetition: {
        activityName: "不参加",
      },
      signedUpCompetitions: [],
      templateInvalid: false,
      dialogTop: (document.documentElement.scrollHeight - 632) / 2,
    };
  },
  computed: {
    dialogProps() {
      let { visible } = this;
      this.dialogTop = (document.documentElement.scrollHeight - 632) / 2;

      return {
        // width: '800px',
        // modal: false,
        "close-on-click-modal": false,
        "modal-append-to-body": false,
        "show-close": false,
        "custom-class": "output-video",
        top: this.dialogTop + "px",
        width: "950px",
        fullscreen: !!this.isPainterSubmit || false,
      };
    },
    titleLength() {
      return this.formData.title.value.length;
    },
    descLength() {
      return this.formData.desc.value.length;
    },
    ...mapGetters([
      "TOOL",
      "WorksName",
      'WorksId',
      "UserMsg",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
      'UserLevelInfo',
      "IsVipSprites",
      "MaterialPane_Size",
      "TopnavMsg",
      "Company",
      "isPersonVip",
      "cooperationDraftId",
      "WorksTemplateIds",
      "IsPrivateDraft",
      "isSolo",
      "isPoor",
      'IsDraftShareShown'
    ]),
    ...mapGetters({
      cover: "Cover", // 自定义封面
      coverForbiddenState: "CoverForbiddenState", // 自定义封面封禁
      projectId: "WorksProjectId",
      subtitleObj: "subtitle/subtitleObj",
      getPlayHandle: "addSoundtrack/getPlayHandle",
    }),
    isFreeUser() {
      return this.UserLevelType === 0 && this.UserLevel === 0;
    },
    isPersonVipUser() {
      return this.isPersonVip;
    },
    isLevel2() {
      return this.UserLevelType === 2;
    },
    isPainterSubmit() {
      return this.TopnavMsg.transferData && this.TopnavMsg.transferData.type;
    },
    tagsItemsMax() {
      return this.isPainterSubmit ? 20 : 5;
    },
    firstFrameCoverDisabled() {
      return this.UserLevel < 0;
    },
    // templateInvalid () {
    //   const ref = this.$refs.painterSubmitRef;
    //   return ref && ref.submitInvalid;
    // }
  },
  watch: {
    "formData.tags.items": function (val) {
      if (val.length >= this.tagsItemsMax) {
        this.formData.tags.isShowInput = false;
      } else {
        this.formData.tags.isShowInput = true;
      }
    },
    "cover.url": function (val) {
      this.activatePreview({
        url: val,
      });
    },
    "formData.watermark": {
      deep: true,
      immediate: true,
      handler(val, oldVal) {
        let key = Object.keys(val).filter((key) => {
          return val[key];
        })[0];
        this.checkedWatermark = this.watermarkInfo[key];
      },
    },
    "formData.watermark.defaults": {
      handler(val) {
        let drr = this.getDrr();
        drr.active = false;

        // if (this.formData.watermark.none) {
        //   drr.active = false;
        // }

        if (val) {
          this.saveMovingHandlerSize({
            w: (drr.rect || {}).w,
            h: (drr.rect || {}).h,
            obj: this.watermarkSizes.custom,
          });

          this.updateMovingHandler({
            w: this.watermarkSizes.defaults.w,
            h: this.watermarkSizes.defaults.h,
          });

          // drr.active = true;
        } else {
          this.saveMovingHandlerSize({
            w: (drr.rect || {}).w,
            h: (drr.rect || {}).h,
            obj: this.watermarkSizes.defaults,
          });

          this.updateMovingHandler({
            w: this.watermarkSizes.custom.w,
            h: this.watermarkSizes.custom.h,
          });
        }

        if (val) {
          $(drr.$el).hide();
        }
      },
    },
    "formData.watermark.custom": {
      handler(val) {
        let customNone = this.watermarkInfo.custom.value === "custom.png";
        let drr = this.getDrr();

        if (val && !customNone) {
          drr.active = true;
        } else {
          drr.active = false;
        }

        if (val) {
          $(drr.$el).show();
        } else {
          $(drr.$el).hide();
        }
      },
    },
    "formData.pixel": {
      deep: true,
      immediate: true,
      handler(val) {
        let key = Object.keys(val).filter((key) => {
          return val[key];
        })[0];
        this.checkedPixel = this.pixelInfo[key];
      },
    },
    "formData.title.value": function (val) {
      this.validateText({ name: "title" });
    },
    "IsVipSprites.type": {
      handler() {
        this.setBadges();
        this.setTips();
      },
    },
    hidden: function () {
      this.judgeBox =
        this.TopnavMsg.transferData && this.TopnavMsg.transferData.type;
      this.painterVideoUrl = "";
      if (this.TopnavMsg.transferData.type == "updataTemplate") {
        this.hidden = true;
        this.submit();
      }
    },

    "watermarkFile.url": {
      async handler(val) {
        this.setDrr(val);
      },
    },

    "checkedPixel.value": {
      handler() {
        if (this.formData.watermark.custom) {
          this.sendInfoToEngine();
        }
      },
    },

    UserMsg() {
      this.initialChecked = this.getShareState();
    },
  },
  created() {
    let key = Object.keys(this.formData.watermark).filter((key) => {
      return this.formData.watermark[key];
    })[0];
    this.checkedWatermark = this.watermarkInfo[key];

    this.getCompetitions();
    this.$bus.on("upLoadingDown_vue", () => {
      if (this.watermarkInfo.custom.value === "custom.png") {
        this.formData.watermark.defaults = true;
        this.formData.watermark.none = false;
        this.formData.watermark.custom = false;
      }
    });

    this.$bus.on("share.getQs", (comp) => {
      let myFormData = this.formData;
      this.shareComp = comp;
      this.shareComp.getQs({
        title: myFormData.title.value,
        desc: myFormData.desc.value,
        pic: this.$handleAssetsUrl(this.screenParam),
      });
    });

    this.$bus.on(
      "expertVideoAfterCompanyInfo",
      ({ company = "", phone = "" } = {}) => {
        this.hasCompanyInfo = true;
        this.formData.company = company;
        this.formData.phone = phone;
        this.doSubmit();
      }
    );

    window.addEventListener("resize", () => {
      this.dialogTop = (document.documentElement.scrollHeight - 632) / 2;
    });
  },
  mounted() {
    this.$bus.on("upload_vue", ({ type, name, data } = {}) => {
      if (type === "image" && name === "imageWatermark") {
        this.watermarkInfo.custom.value = data.filename;
        this.watermarkFile.url = this.$handleAssetsUrl(data.filename);
        this.onClickRadio({
          info: this.watermarkInfo,
          items: this.formData.watermark,
          key: "custom",
        });
      }
    });

    // 关闭上传窗口时
    document.getElementById("imageWatermark").addEventListener("click", () => {
      const vm = this;
      window.addEventListener("focus", function h() {
        window.removeEventListener("focus", h);
        if (
          vm.formData.watermark.custom &&
          vm.watermarkInfo.custom.value === "custom.png"
        ) {
          vm.onClickRadio({
            items: vm.formData.watermark,
            key: "defaults",
            info: vm.watermarkInfo,
            name: "watermark",
          });
        }
      });
    });

    this.$bus.on('coverAudit', this.coverAudit);
  },
  methods: {
    chooseActivityAction({ item }) {
      this.choosedCompetition = item;
    },
    getCompetitions() {
      this.$http
        .get("/api/promotion/applies")
        .then((res) => {
          let tempData = res.data.data || [];
          if (tempData.length > 0) {
            let not1 = {
              activityName: "不参加",
            };
            tempData.unshift(not1);
            this.signedUpCompetitions = tempData;
            console.log("signedUpCompetitions", this.signedUpCompetitions);
          }
        })
        .catch(() => {});
    },
    close() {
      this.$emit("closeDialog");
      this.formData.snaps = [];
      this.restoreContentLayer(this.TOOL.getSelectScenes());
      this.$store.commit("clear_Cover");
      this.hidden = true;
      this.judgeBox = false;
      this.isShowCompanyInfo = false;
      this.hasCompanyInfo = false;
    },
    onOpenDialog() {
      this.getLimit();
      this.formData.title.value = this.WorksName;
      this.formData.snaps = [];
      this.isLock = false;
      try {
        this.getSnaps();
      } catch (e) {
        console.warn(e);
      }
      this.setBadges();
      this.setTips();
      if (this.$refs.memberFooter) {
        this.$refs.memberFooter.currAction =
          this.$refs.memberFooter.getAction();
      }

      this.toolOptimized = this.TOOL.optimized;
      this.onClickRadio({
        items: this.formData.watermark,
        key: "defaults",
        info: this.watermarkInfo,
        name: "watermark",
      });
      this.onClickRadio({
        items: this.formData.pixel,
        key: "480p",
        info: this.pixelInfo,
        name: "pixel",
      });

      if (this.TOOL.watermarkInfo && this.TOOL.watermarkInfo.url) {
        this.$set(
          this.watermarkInfo.custom,
          "value",
          this.TOOL.watermarkInfo.url
        );
        this.$set(
          this.watermarkFile,
          "url",
          this.$handleAssetsUrl(this.TOOL.watermarkInfo.url)
        );
      }

      sensors.track('exportVideoClick', {
        version: '5.6.3'
      });
    },

    // 输入自定义封面到input标签
    getCoverFile() {
      // if (this.UserEquity.noCustomCover) {
      //   this.$memberGuide({
      //     show: true,
      //     funcRight: {
      //       type: "selfDefineCover",
      //       name: "自定义视频封面",
      //     },
      //   });
      //   return;
      // }
      this.$refs.fileInputRef.click();
    },

    // input标签中的自定义封面变更时
    onChangeCoverFile(ev) {
      let { files } = this.$refs.fileInputRef;
      if (files[0].size > 10 * 1024 * 1024) {
        this.$message({
          type: "error",
          message: "选中图片已经超出10MB限制",
        });
        this.$refs.fileInputRef.value = "";
        return;
      }
      this.$bus.emit("FeaturesPop_close_vue", {
        // 关闭弹窗
        type: 3,
      });
      this.uploadThumbnail = window.URL.createObjectURL(files[0]);
      this.$store.commit("save_TopnavMsg", {
        isShowCoverDialog: true,
      });
      this.$store.commit("save_Cover", {
        url: this.uploadThumbnail,
      });
      this.$refs.fileInputRef.value = "";

      this.backupCover = this.previewCoverUrl;
    },

    // 从几张预览图中选一张作为封面
    activatePreview({ url = "" } = {}) {
      this.previewCoverUrl = url || this.backupCover;
      let mySnap = this.formData.snaps.filter((snap) => {
        return snap.url === url;
      })[0];
      if (mySnap) {
        this.previewCoverBlob = mySnap.blob;
        this.isShowSwapCoverBtn = false;
      } else {
        this.previewCoverBlob = this.cover.blob;
        this.isShowSwapCoverBtn = true;
      }
    },

    // 校验一般input文本
    validateText({ name } = {}) {
      let opts = this.formData[name];
      let pass = opts.validate();
      opts.validFail = !pass;
    },

    // 作品标签相关 start
    valiateTagInput() {
      let opts = this.formData.tags;
      let pass = opts.validate();
      if (pass) {
        opts.validFail = false;
        opts.forceHidden = true;
      } else {
        opts.forceHidden = false;
        opts.validFail = true;
      }
    },
    onBlurTagInput() {
      if (!this.formData.tags.value) {
        this.formData.tags.forceHidden = true;
        return;
      }
      let pass = this.formData.tags.validate();
      if (pass) {
        this.formData.tags.forceHidden = true;
        this.$nextTick(() => {
          this.pushTag();
        });
        return;
      }
      if (!pass) {
        let str = this.formData.tags.value;
        let re = /[^\x00-\xff]/;
        let chars = this.formData.tags.value.split("");
        let charsLen = chars.length;
        while (getMixLen(str) > this.formData.tags.limitLength) {
          charsLen--;
          chars.length = charsLen;
          str = chars.join("");
        }
        this.formData.tags.value = str;
        this.formData.tags.forceHidden = true;
        this.$nextTick(() => {
          this.pushTag();
        });
        return;
      }
      this.formData.tags.forceHidden = false;
    },
    pushTag() {
      let { tags } = this.formData;
      let trimed = tags.value.trim(); // tags.value.replace(/\s*/, '')
      // if (!trimed) {
      //   return;
      // }
      tags.value = trimed;
      let pass = tags.validate();
      if (!pass) {
        tags.validFail = !pass;
        this.formData.tags.forceHidden = false;
        return;
      }
      tags.items.push({ text: tags.value, hover: false });
      tags.value = "";
      tags.validFail = false;
      tags.forceHidden = true;
    },
    removeTag(index) {
      let { tags } = this.formData;
      tags.items.splice(index, 1);
    },
    onMouseEnterTag(tag, i) {
      tag.hover = true;
    },
    onMouseLeaveTag(tag, i) {
      tag.hover = false;
    },
    // 作品标签相关 end

    onClickRadio({ info, items, key, name } = {}) {
      const vm = this;
      let isBreak = false;
      Object.keys(items).forEach((k) => {
        if (k === key) {
          // let isTmpUser = vm.UserMsg.tmpLevelType != null;
          if ((key === "none" || key === "custom") && !vm.UserEquity.closeWaterMark) {
            if (
              // (vm.UserLevelType === 0 && vm.UserLevel === 0) ||
              // vm.UserMsg.tmpLevelType != null ||
              // vm.isPersonVip ||
              // vm.UserLevelType === 1
              vm.watermarkInfo[key].isVip
            ) {
              this.$memberGuide({
                show: true,
                context: this,
                funcRight: {
                  type: "applyWatermark",
                  name: "去水印/自定义水印",
                },
              });
              isBreak = true;
            }
          }
          // else if (key === "custom" && !vm.UserEquity.waterMark) {
          //   this.$memberGuide({
          //     show: true,
          //     funcRight: {
          //       type: "applyWatermark",
          //       name: "去水印/自定义水印",
          //     },
          //   });
          //   isBreak = true;
          // }
          else if (key === "720p") {
            if (
              vm.UserEquity.imgQuality < 720 ||
              (vm.UserMsg.transformRemain <= 0 &&
                720 === vm.UserEquity.imgQuality)
            ) {
              // console.log("imgQuality");
              this.$memberGuide({
                show: true,
                context: this,
                funcRight: {
                  type: "720P",
                  name: "720P导出",
                },
              });
              isBreak = true;
            }
          } else if (key === "1080p") {
            if (
              (vm.UserEquity.imgQuality === 1080 &&
                this.UserMsg.transformRemain <= 0) ||
              vm.UserEquity.imgQuality < 1080
            ) {
              this.$memberGuide({
                show: true,
                context: this,
                funcRight: {
                  type: "1080P",
                  name: "1080P导出",
                },
              });
              isBreak = true;
            }
          } else {
            items[k] = true;
          }
        }
      });
      if (isBreak) {
        return;
      }

      Object.keys(items).forEach((k) => {
        if (k === key) {
          if (key === "custom" && info.custom.value === "custom.png") {
            document.getElementById("imageWatermark").click();
          }
          if (key === "custom") {
            this.watermarkFile.isShow = true;
          } else if (name === "watermark") {
            this.watermarkFile.isShow = false;
          }
          items[k] = true;
        } else {
          items[k] = false;
        }
      });
    },
    onUploadWatermark() {
      let { nonWatermarkRemain } = this.UserMsg;
      // if (!this.UserEquity.waterMark) {
      if (!nonWatermarkRemain) {
        this.$memberGuide({
          show: true,
          context: this,
          funcRight: {
            type: "applyWatermark",
            name: "去水印/自定义水印",
          },
        });
        return;
      }
      document.getElementById("imageWatermark").click();

      let drr = this.getDrr();
      setTimeout(() => {
        drr.active = false;
      }, 500);
    },

    // 上传截图封面
    uploadCoverOthers() {
      let { snaps } = this.formData;
      let addedCover = this.cover;
      let tasks = [];
      snaps.forEach(async (cover) => {
        if (/* this.previewCoverBlob === cover.blob ||  */ !cover.blob) {
          return;
        }

        let formData = new FormData();
        formData.append("draft_thumbnail", cover.blob);
        formData.append("isScreen", 1);
        let p = () => {
          let myResolve;
          this.$http({
            url: "/api/upload/file",
            method: "post",
            data: formData,
          }).then(({ data: resData }) => {
            let { code, data } = resData;
            if (code >= 300) {
              return;
            }
            myResolve({
              filename: data.filename,
              active: this.previewCoverBlob === cover.blob,
            });
          });
          return new Promise((resolve, reject) => {
            myResolve = resolve;
          });
        };

        tasks.push(p());
      });
      return tasks;
    },

    // 上传自定义封面
    uploadCover(blob) {

      // 如果已经上传并审核图片封禁就用 已审核的图片
      if (this.coverForbiddenState.url && this.coverForbiddenState.state === 3) {
        return new Promise((resolve) => {
          resolve({
            filename: this.coverForbiddenState.url,
            active: this.previewCoverBlob === blob,
          });
        });
      }

      let myResolve;
      let urlapi = "/api/upload/file";
      let formData = new FormData();
      formData.append("files[]", blob);
      formData.append("isScreen", 1);

      this.$http({
        url: urlapi,
        method: "post",
        data: formData,
      }).then((res) => {
        let { code, data } = res.data;
        if (code >= 300) {
          return;
        }
        this.paramCoverUrl = data.filename;
        myResolve({
          filename: data.filename || "",
          active: this.previewCoverBlob === blob,
        });
      });

      return new Promise((resolve, reject) => {
        myResolve = resolve;
      });
    },

    submit() {
      let payingList = this.IsVipSprites.data || [];
      if (
        this.UserMsg.payForMaterial == 1 &&
        payingList.length &&
        (!this.Company.name || !this.Company.phone)
      ) {
        this.isShowCompanyInfo = true;
      } else {
        this.doSubmit();
      }
    },

    // 将付费ip绑定
    async bindUseIp() {
      const ipList = [];
      console.log(this.useIpLists);
      for (const v of this.useIpLists) {
        console.log(v);
        const res = await this.$http.get('/api/common/character/actionsAndCharacter', {
          params: {
            id: v.option.resourceId
          }
        })
        console.log(res);
        if (res.data.data !== null) {
          ipList.push(res.data.data)
        }
      }
      console.log(this.ipList);
      for (const i of ipList) {
        await this.$http.post('/api/user/character/useIp',{
            id: i.uid,
            draftId: this.WorksId
          }
        )
      }
    },

    // 提交数据相关 start
    doSubmit() {
      this.bindUseIp()
      let allInputPass = true;
      let { title, tags, desc } = this.formData;
      let inputs = { title, tags };
      Object.keys(inputs).every((key) => {
        let item = inputs[key];
        let pass;
        pass = item.validate();
        if (!pass) {
          this.$message.error({
            message: item.validTip,
          });
          allInputPass = false;
          this.$refs[`${key}InputRef`].focus();
        }

        return pass;
      });

      if (!allInputPass) {
        return;
      }

      if (this.isLock) {
        return;
      }
      this.isLock = true;

      this.messageInstance = this.$message({
        message: "正在提交数据...",
        duration: 0,
      });
      const watermarkType = this.checkedWatermark.value;
      if (watermarkType === "default" || !watermarkType) {
        this.TOOL.watermarkInfo = false;
      }
      this.getSoundJson();
      let tasks = this.uploadCoverOthers();
      let p = this.cover.blob ? this.uploadCover(this.cover.blob) : false;
      tasks = p ? [...tasks, p] : tasks;
      let hasSubmit = false;
      let myCovers = [];
      Promise.all(tasks)
        .then((arr) => {
          // let covers = JSON.stringify(arr);
          let covers = arr
            .map((item) => {
              if (item.active) {
                this.screenParam = item.filename;
              }
              return item.filename;
            })
            .join(",");
          myCovers = covers;

          saveWorks.call(this, covers);
        })
        .catch((err) => {
          this.isLock = false;
          this.messageInstance && this.messageInstance.close();

          saveWorks.call(this);
        });

      setTimeout(() => {
        if (!hasSubmit) {
          // this.submit_({
          //   covers: myCovers
          // });
          saveWorks.call(this);
        }
      }, 10000);

      function saveWorks(covers) {
        this.emitSaveWorks({
          covers: covers || this.paramCoverUrl,
          screen: this.screenParam,
          isFirstFrameCover: this.isFirstFrameCover,
          onCompleted: () => {
            hasSubmit = true;
            this.submit_({
              covers,
            });
          },
        });
        // this.$bus.once('saveWorks.completed', () => {
        //   hasSubmit = true;
        //   this.submit_({
        //     covers
        //   });
        // });

        // hasSubmit = true;
        // this.submit_({
        //   covers
        // });
      }
    },
    getExtraParam() {
      let extraParam = {};
      if (this.choosedCompetition.hasOwnProperty("activityId")) {
        extraParam.activityId = this.choosedCompetition.activityId;
      }
      console.log("getExtraParam", extraParam);
      return extraParam;
    },
    async submit_({ covers } = {}) {
      _hmt.push([
        "_trackEvent",
        "export_video",
        "click_nextstep",
        "导出视频_下一步",
      ]);
      let myFormData = this.formData;
      let extraParam = this.getExtraParam();

      // qh 360
      const dataOfQhClickId = JSON.parse(localStorage.getItem('qhclickid') || '{}');
      if (dataOfQhClickId.val) {
        let _val = dataOfQhClickId.val;
        if (typeof _val === 'string') {
          _val = JSON.parse(_val);
        }
        const qhClickId = _val.qhclickid || void 0;
        await this.$http.post('/api/common/user/video/ocpc', {
          qhclick_id: qhClickId
        });
      }

      let videoData = {
        // 必传
        projectId:
          this.cooperationDraftId || this.projectId || window.uuid.generate(),
        // isTmp: 1,
        times: this.TOOL.getDuration() / 1000,

        // 输入框
        title: myFormData.title.value,
        tags: this.getParamTags(),
        description: myFormData.desc.value,

        // 封面
        thumbnailUrl: covers || this.paramCoverUrl,

        // 默认显示的封面
        screen: this.screenParam,

        // toJson
        data: this.getToJson(),

        // 单选框
        watermark: this.checkedWatermark.value,
        resolution: this.checkedPixel.value,

        // 音乐
        music: this.getSoundJson(),

        // 横屏竖屏
        optimized: this.TOOL.optimized,
        direction: this.TOOL.getOptimizedNum(),

        // 作品展示授权
        shareToSquare: this.$refs.checkboxShare
          ? this.$refs.checkboxShare.getCheckedNum()
          : 1,

        // extra 大赛活动
        ...extraParam,
      };
      videoData.company = this.Company.name;
      videoData.phone = this.Company.phone;
      if (this.isShowCompanyInfo) {
        videoData.company = this.formData.company || videoData.company;
        videoData.phone = this.formData.phone || videoData.phone;
      }

      if (typeof videoData.thumbnailUrl !== "string") {
        videoData.thumbnailUrl = "";
      }

      if (this.judgeBox) {
        videoData.watermark = "";
        videoData.isTmp = 1;
        videoData.resolution = 1080;
        delete videoData.shareToSquare;
        delete videoData.activityId;
      } else {
        videoData = Object.assign(extraParam, videoData);
        this.setShareState(videoData.shareToSquare ? "on" : "off");
      }
      switch (this.TopnavMsg.transferData.type) {
        case "combination":
          this.painterVideoUrl = "";
          this.painterVideoUrl = videoData;
          this.messageInstance.close();
          return;
        case "template":
          this.formData.title.value = this.$refs.painterSubmitRef.title;
          videoData.title = this.$refs.painterSubmitRef.title;
          break;
      }

      // 再次确认弹窗
      // let confirmAgainChecked = this.$util.localStorage.get(
      //   "export.confirmAgainChecked"
      // );
      // if (
      //   // (this.isFreeUser || this.isLevel2) &&
      //   this.checkedPixel.value - 0 >= this.UserMsg.resolution &&
      //   this.UserMsg.transformRemain < 999 &&
      //   !confirmAgainChecked &&
      //   !this.forceSubmit
      // ) {
      //   this.$modal.show("confirmAgain");
      //   this.forceSubmit = true;
      //   this.$bus.once("confirmAgain.confirm", this.submit);
      //   this.$bus.once("confirmAgain.closed", () => {
      //     this.forceSubmit = false;
      //   });
      //   this.messageInstance.close();
      //   this.isLock = false;
      //   return;
      // }
      // this.forceSubmit = false;

      return this.payForMaterial().then((resp) => {
        if (resp && resp.code != 200) {
          this.$message({
            message: resp.msg || "提交订单失败",
            type: "error",
          });
          this.isLock = false;
          return;
        }
        let cRisk = this.$store.getters["CommercialRisk"];
        cRisk = cRisk && cRisk.length;
        sensors.track('clickExport', {
          version: '5.6.3',
          template_id: this.WorksTemplateIds.join(',') || '',
          draft_id: this.WorksId || '',
          video_duration: videoData.times || 0
        });
        return this.$http
          .post("/api/user/video", {
            ...videoData,
            ...this.handleTrackingType(),
            haveInCommerical: cRisk ? 1 : 0,
          })
          .then(async (res) => {
            this.videoResponse = res.data.data;
            this.messageInstance && this.messageInstance.close();
            if (res.data.code >= 200 && res.data.code < 300) {
              this.$modal.hide("confirmAgain");
              if (this.judgeBox) {
                if (res.data.data.payList) {
                  this.$bus.emit("Modal_vue", {
                    name: "delVip",
                    data: {
                      type: "record",
                    },
                  });
                } else {
                  this.painterVideoUrl = "";
                  videoData.painterVideoUrl = res.data.data.url;
                  videoData.videoId = res.data.data.id;

                  if (
                    this.$refs.painterSubmitRef &&
                    this.$refs.painterSubmitRef.judgeBox
                  ) {
                    this.painterVideoUrl = {
                      ...videoData,
                      title: this.$refs.painterSubmitRef.title,
                      description: this.$refs.painterSubmitRef.desc,
                    };
                  } else {
                    this.painterVideoUrl = videoData;
                  }
                }
              } else {
                if (res.data.data.payList && res.data.data.payList.length) {
                  this.$bus.emit("Modal_vue", {
                    name: "delVip",
                    data: {
                      type: "record",
                    },
                  });
                  this.isLock = false;
                  return res;
                }

                // this.$store.commit("save_WorksName", videoData.title);
                // this.emitSaveWorks({
                //   covers: videoData.thumbnailUrl,
                //   screen: videoData.screen,
                //   isFirstFrameCover: this.isFirstFrameCover,
                //   onCompleted: () => {
                //     this.openPage(
                //       res.data.data.id,
                //       extraParam.activityId
                //         ? `&contest=${extraParam.activityId}`
                //         : ""
                //     );
                //   },
                // });
                let extra = extraParam.activityId
                  ? `&contest=${extraParam.activityId}`
                  : "";
                const recordResp = await this.$http.get('/api/user/info/record?type=10');
                if (!recordResp.data.data) {
                  extra += '&first-export=1';
                  // record and add 24 hours
                  await this.$http.post('/api/user/info/record', {
                    type: 10
                  });
                  // if (this.UserLevelInfo.levelName === 'basic' || this.UserLevelInfo.levelName === 'person' && this.UserLevelInfo.trial) {
                  // }
                }

                this.openPage(
                  res.data.data.id,
                  extra
                );

                this.$message({
                  message: "提交数据成功",
                  type: "success",
                });
              }
            } else {
              if (this.$refs.memberFooter) {
                this.$refs.memberFooter.currAction =
                  this.$refs.memberFooter.getAction();
              }

              if (res.data.code === 412) {
                this.$memberGuide({
                  show: true,
                  context: this,
                  funcRight: {
                    type: "480P",
                    name: "480P导出",
                  },
                });
              } else {
                this.$message({
                  message: res.data.msg || "提交数据失败",
                  type: "error",
                });
              }
              this.isLock = false;
            }

            return res;
          })
          .catch((err) => {
            this.isLock = false;
            this.messageInstance && this.messageInstance.close();
          });
      });
    },
    handleTrackingType() {
      let hasSubtitle =
        this.subtitleObj &&
        this.subtitleObj.contents &&
        this.subtitleObj.contents.length > 0;
      let musicArr = this.$store.getters["addSoundtrack/getMusicArr"] || [];
      let trackingType = this.TOOL.getTrackingType();
      let dict = {
        isPersonalMaterial: trackingType[0] == 1,
        isLensFunction: (this.TOOL.sprites || []).some((v) => {
          return (
            v.camera &&
            v.camera.cameras.some((vv) => {
              let d = vv.matrix || {};
              return d.w !== v.camera.maxWidth && d.h !== v.camera.maxHeight;
            })
          );
        }),
        isWordCloud: trackingType[3] == 1,
        isBackgroundMusic:
          !!(this.TOOL.sound && this.TOOL.sound.url) || musicArr.length > 0,
        isAutodraw: trackingType[2] == 1,
        isAIDubbing: trackingType[1] == 1,
        isInsertCoverToMp4: !!this.isFirstFrameCover,
        backgroundMusicNumber: musicArr.length || 0,
        isSubtitles: hasSubtitle,
        exportType: '后端导出',
        toolVersion: '5.6.3'
      };
      return dict;
    },
    saveDraftAndJump () {
      this.$store.commit("save_WorksName", this.formData.title.value);
      this.$bus.emit("topnav.saveWorks", {
        coverUrls: this.paramCoverUrl,
        screenParam: this.screenParam,
      });
      this.$bus.once("saveWorks.completed", () => {
        let extraParam = this.getExtraParam();
        this.openPage(
          this.videoResponse.id,
          extraParam.activityId ? `&contest=${extraParam.activityId}` : ""
        );
      });
    },
    openPage(id, extra = "") {
      // if (location.host.indexOf('laihua')  < 0) {
      //   console.warn('wrong host');
      //   return;
      // }

      // 跳转前无须提示退出
      window.onbeforeunload = null;
      // old -- /workbench/creation
      if (this.cooperationDraftId) {
        // 跳转团队工作台
        location.replace(`/dashboard/studio/works`);
        return;
      }
      id && location.replace(`/dashboard/creator/all/works?videoId=${id}` + extra);
    },
    isRightsRisk() {
      let removed = this.IsVipSprites.data.filter((v) => v.removed) || [];
      let noFont = this.IsVipSprites.data.filter((v) => v.fileType != 15);
      return (
        removed.length ||
        this.hasPayFont() ||
        (this.UserMsg.payForMaterial != 1 &&
          (noFont.length || this.UserEquity.isEchart))
      );
    },
    payForMaterial() {
      let payingList = this.IsVipSprites.data || [];
      let paying = [];
      if (this.UserMsg.payForMaterial == 1) {
        let arr = payingList.filter((v) => v.fileType != 15);
        paying = [...paying, ...arr];
      }
      if (this.UserMsg.payForFont == 1) {
        let arr = payingList.filter((v) => v.fileType == 15);
        paying = [...paying, ...arr];
      }
      if (paying && paying.length) {
        return this.$http
          .post("/api/user/material/orders", {
            dataList: JSON.stringify(
              payingList.map((item) => ({
                id: item.resourceId,
                fileType: item.fileType,
                payType: 1,
                showType: 100,
              }))
            ),
            draftId: this.projectId,
          })
          .then((res) => {
            return res.data;
          });
      }

      return Promise.resolve();
    },
    getParamTags() {
      let arr =
        this.formData.tags.items.map((item) => {
          return {
            name: item.text,
          };
        }) || [];
      if (!arr || (arr && !arr.length)) {
        return "";
      }
      return JSON.stringify(arr);
    },
    getToJson() {
      // let data = {};
      // if(this.TopnavMsg.transferData.platform == 6){
      //   data = this.TOOL.toJson();
      // }else if(this.TopnavMsg.transferData.platform == 2){
      //   data = this.TOOL.toAppJson();
      // }

      // 导出作品不兼容app，提交模板兼容app
      // if (this.TopnavMsg.transferData.platform == 2) {
      //   this.TOOL.targetPlatform = "App";
      // }

      let data = this.TOOL.toJson() || {};

      if (
        this.$refs.painterSubmitRef &&
        this.$refs.painterSubmitRef.judgeBox &&
        this.$refs.painterSubmitRef.payType === 0
      ) {
        data.scenes.forEach((v) => {
          v.sprites.forEach((s) => {
            if (s.artType) {
              s.templateFree = true;
            }
          });
        });
      }
      if (this.isFirstFrameCover) {
        data.cover = this.screenParam;
      }
      data.subtitle = this.subtitleObj;
      if (
        this.getPlayHandle.musicLoop &&
        data.music.data &&
        data.music.data.length
      ) {
        let music = data.music.data.slice(0, 1);
        let voice = data.music.data.slice(1);
        let allTime = music[0].timeSlot[1] - music[0].timeSlot[0];
        let dur = music[0].cut[1] - music[0].cut[0];
        let n = Math.floor(allTime / dur);
        let musics = [];
        for (let i = 0; i < n; i++) {
          let start = i * dur;
          let end = (i + 1) * dur;
          musics[i] = Object.assign({}, music[0], { timeSlot: [start, end] });
        }
        musics.push(
          Object.assign({}, music[0], { timeSlot: [n * dur, allTime] })
        );
        musics = musics.concat(voice);
        // console.log('voice:', voice);
        // console.log('voice:', musics);
        data.music.data = musics;
      }
      data = JSON.stringify(data);
      return data;
    },
    getSoundJson() {
      let data = this.TOOL.toJson() || {};
      let json = this.TOOL.sounds2json(data) || [];
      if (!json || (json && !json.length)) {
        return "";
      }
      return JSON.stringify(json);
    },
    // 提交数据相关 end

    // 截取封面相关 start
    getSnaps() {
      const vm = this;
      let scenes = this.TOOL.sprites;
      let cacheScene = this.TOOL.getSelectScenes();
      let pointObj = vm.getMiddlePoint();
      let jqPlayer = this.TOOL.player.ele;
      jqPlayer.show();
      let startDom; //= this.TOOL.contentBody[0]
      let myTasks = [];
      myTasks[0] = () => {
        return new Promise((resolve) => {
          let dur = vm.TOOL.sprites[0].getDuration();
          let point = dur > 1000 ? 1000 : 500;
          // 截取第一场第一秒
          let ms = point;
          switch (this.TopnavMsg.transferData.type) {
            case "combination":
              let combinationScenes = this.TOOL.selectedScenes;
              dur = combinationScenes.getDuration();
              point = dur > 1000 ? 1000 : 500;
              ms = point;
              // eve('playByFrame', null, parse(ms), combinationScenes.id);
              this.TOOL.eve.emit("play_" + combinationScenes.id, parse(ms));
              this.getSnapByDom(combinationScenes.element.content[0], {
                sec: ms / 1000,
                combinationScenes,
              }).then(() => {
                resolve();
              });
              break;
            default:
              // eve('playByFrame', null, parse(ms), this.TOOL.sprites[0].id);
              this.TOOL.eve.emit("play_" + this.TOOL.sprites[0].id, parse(ms));
              const palyerScene =
                jqPlayer.find("#player-scene-" + scenes[0].id)[0] ||
                scenes[0].element.content[0];
              this.getSnapByDom(
                startDom || palyerScene || scenes[0].element.content[0],
                { sec: ms / 1000, scene: scenes[0] }
              ).then(() => {
                resolve();
              });
          }
        });
      };
      myTasks[1] = () => {
        this.activatePreview({
          url: (this.formData.snaps[0] || {}).url,
        });

        return Promise.resolve();
      };
      myTasks[2] = () => {
        return new Promise((resolve, reject) => {
          switch (this.TopnavMsg.transferData.type) {
            case "combination":
              let combinationScenes = this.TOOL.selectedScenes;
              let duration = combinationScenes.getDuration();

              // eve('playByFrame', null, parse(duration/2), combinationScenes.id);
              this.TOOL.eve.emit(
                "play_" + combinationScenes.id,
                parse(duration / 2)
              );
              vm.getSnapByDom(combinationScenes.element.content[0], {
                sec: duration / 2 / 1000,
                scene: combinationScenes,
              })
                .then(() => {
                  resolve();
                })
                .catch((err) => {
                  reject(err);
                });
              break;
            default:
              // eve('playByFrame', null, parse(pointObj.diffTime), vm.TOOL.sprites[pointObj.index].id);
              this.TOOL.eve.emit(
                "play_" + vm.TOOL.sprites[pointObj.index].id,
                parse(pointObj.diffTime)
              );
              vm.getSnapByDom(
                startDom ||
                  jqPlayer.find(
                    "#player-scene-" + scenes[pointObj.index].id
                  )[0] ||
                  scenes[pointObj.index].element.content[0],
                { sec: pointObj.diffTime / 1000, scene: scenes[pointObj.index] }
              )
                .then(() => {
                  resolve();
                })
                .catch((err) => {
                  reject(err);
                });
          }
        });
      };
      myTasks[3] = () => {
        return new Promise((resolve, reject) => {
          switch (this.TopnavMsg.transferData.type) {
            case "combination":
              let combinationScenes = this.TOOL.selectedScenes;
              let duration = combinationScenes.getDuration();

              // eve('playByFrame', null, parse(duration), combinationScenes.id);
              this.TOOL.eve.emit(
                "play_" + combinationScenes.id,
                parse(duration)
              );
              vm.getSnapByDom(combinationScenes.element.content[0], {
                sec: duration / 1000,
                scene: combinationScenes,
              })
                .then(() => {
                  onOpsEnd();
                  resolve();
                })
                .catch((err) => {
                  reject(err);
                });
              break;
            default:
              let id = scenes[scenes.length - 1].id;
              let point = scenes[scenes.length - 1].duration - 1000;
              // eve('playByFrame', null, parse(point), id);
              this.TOOL.eve.emit("play_" + id, parse(point));
              this.getSnapByDom(
                startDom ||
                  jqPlayer.find(
                    "#player-scene-" + scenes[scenes.length - 1].id
                  )[0] ||
                  scenes[scenes.length - 1].element.content[0],
                { sec: point / 1000, scene: scenes[scenes.length - 1] }
              ).then(() => {
                onOpsEnd();
                resolve();
              });
          }
        });
      };

      let process = () => {
        return myTasks[0]()
          .then(myTasks[1])
          .then(myTasks[2])
          .then(myTasks[3])
          .catch((err) => {
            onOpsEnd();
            console.warn(err);
          });
      };

      // 显示content层的素材
      function showSprites(scene) {
        let { duration, nowTime } = scene;
        let sec = nowTime;
        nowTime *= 1000;
        scene.sprites.forEach((sprite) => {
          sprite.effect._syncContent(parse(nowTime));
        });

        // scene.updateBgVideo(scene.nowTime * scene.editor.option.frameRate)
      }

      // video sprite and video bg
      function syncVideoCurrentTime() {
        vm.TOOL.sprites.forEach((scene) => {
          scene.updateBgVideo(scene.nowTime * scene.editor.option.frameRate);
          (scene.sprites.filter((s) => s.type === "Video") || []).map((v) => {
            v.updateCurrentTimeBySec(scene.nowTime);
          });
        });
      }

      function onOpsEnd() {
        // vm.TOOL.selectScenes(cacheScene);

        // 隐藏player层
        vm.TOOL.cancelPlay();
        cacheScene.show();
        showSprites(cacheScene);
        syncVideoCurrentTime();

        vm.$store.commit("save_TopnavMsg", {
          isShowSavingMask: false,
        });
        vm.hidden = false;
      }

      function parse(n) {
        return (n / 1000) * 60;
      }

      // this.TOOL.selectScenes(scenes[0])
      //   .then(() => {

      //   })

      return process();
    },
    async getSnapByDom(dom, { sec, scene } = {}) {
      let myResolve;
      dom.style.display = "";
      let $video = $(dom).find("video");
      let imgWrapper;
      let extraShowEl = [];

      if ($video[0]) {
        await this.beforeGetSnap({ palyerScene: dom, sec, scene });
      }
      // let isLatestChromeDev
      // if (isLatestChromeDev) {
      //   await this.addBlobs(dom);
      // }

      const widthReference = 1280;

      domtoimage
        .toBlob2(dom, {
          useFont: false,
          bgcolor: "transparent",
          quality: 0.5,
          style: {
            overflow: "hidden",
            // transform: `scale(${400 / dom.offsetWidth})`,
            // transformOrigin: '0 0'
          },
          _width: dom.offsetWidth,
          _height: dom.offsetHeight,
          width: widthReference,
          height: (widthReference * dom.offsetHeight) / dom.offsetWidth,
          filter: (node) => {
            // let isMask = node && node.classList && node.classList.contains('mask-blur');
            // console.log({node, bool: isMask})

            try {
              if ($(node).css("display") === "none") {
                return false;
              }
            } catch (e) {}

            let isPass = true;

            let notVideo = node.tagName !== "VIDEO";
            isPass = notVideo;
            let isImg = node.tagName === "IMG";
            let isHandWriteSvg =
              node.classList && node.classList.contains("_my-hand-player-svg");
            if (isHandWriteSvg) {
              $(node).parent().css("display") !== "none" &&
                extraShowEl.push($(node).next().show());
            }
            let hasSpecial =
              node.classList &&
              (node.classList.contains("frame-image") || isHandWriteSvg);
            if (hasSpecial) {
              isPass = false;
            }
            if (isImg) {
              isPass = node.src && node.src.length > 0;
            }

            return isPass;
          },
          fontFilter: (node) => {
            let fontFamily = node.style.fontFamily;
            const hasStyleFont = /.+\.ttf/i.test(fontFamily);
            return hasStyleFont;
          },
        })
        .then(async (blob) => {
          if (extraShowEl.length) {
            extraShowEl.forEach((el) => {
              el.hide();
            });
          }
          if (this.TOOL.optimized !== "Horizontal") {
            let height = (widthReference * dom.offsetHeight) / dom.offsetWidth;
            let width = (height * 9) / 16;
            setBlobImageSize({
              blob,
              height,
              width,
              sx: (widthReference - width) / 2,
              sy: 0,
              sw: width,
              sh: height,
            }).then((blob) => {
              this.formData.snaps.push({
                blob,
                url: this.getBlobUrl(blob),
              });
              dom.style.display = "none";
              myResolve();
            });

            return;
          }
          this.formData.snaps.push({
            blob,
            url: this.getBlobUrl(blob),
          });
          dom.style.display = "none";
          myResolve();
        })
        .catch((err) => {
          console.warn(err);
          myResolve();
        })
        .finally(() => {
          this.TOOL.sprites.forEach(scene => {
            scene.sprites.forEach(sprite => {
              if (sprite.type === 'Video') {
                const ele = document.getElementById('sprite-' + sprite.id);
                ele.style.backgroundImage = ''
                const playerEle = document.getElementById('player-sprite-' + sprite.id);
                playerEle.style.backgroundImage = ''
              }
            })
          });
        })

      return new Promise((resolve) => {
        myResolve = resolve;
      });
    },
    restoreContentLayer(scene) {
      this.TOOL.cancelPlay();
      if (!scene) {
        return;
      }
      scene.show();
      let { duration, nowTime } = scene;
      nowTime *= 1000;
      scene.sprites.forEach((sprite) => {
        sprite.effect._syncContent(parse(nowTime));
      });
      function parse(n) {
        return (n / 1000) * 60;
      }
    },
    // 截取封面相关 end

    // vip提示相关 start
    setBadges() {
      let obj = {
        ...this.watermarkInfo,
        ...this.pixelInfo,
      };
      let { nonWatermarkRemain, updateWatermarkRemain } = this.UserMsg;
      if (this.UserLevelType > 1) {
        // obj.none.isVip = false;
        // obj.custom.isVip = false;
        obj["720p"].isVip = false;
        obj["1080p"].isVip = this.UserEquity.imgQuality < 1080;
        if (this.UserMsg.tmpLevelType) {
          obj.none.isVip = !this.UserEquity.closeWaterMark;
          obj.custom.isVip = !this.UserEquity.waterMark;
        }
      } else if (this.UserLevelType === 1) {
        // obj.none.isVip = !nonWatermarkRemain;
        // obj.custom.isVip = !updateWatermarkRemain;
        obj["720p"].isVip = false;
        obj["1080p"].isVip = true;
      } else if (this.isPersonVip) {
        // obj.none.isVip = !nonWatermarkRemain;
        // obj.custom.isVip = !nonWatermarkRemain;
        obj["720p"].isVip = false;
      } else {
        // obj.none.isVip = !nonWatermarkRemain;
        // obj.custom.isVip = !nonWatermarkRemain;
        obj["720p"].isVip = true;
        obj["1080p"].isVip = true;
      }

      obj.none.isVip = !nonWatermarkRemain;
      obj.custom.isVip = !nonWatermarkRemain;

      if (this.UserMsg.tmpLevelType && this.UserMsg.tmpLevelType >= 1) {
        obj.none.isVip = !nonWatermarkRemain;
        obj.custom.isVip = !updateWatermarkRemain;
      }
    },
    setTips() {
      let obj = {
        ...this.watermarkInfo,
        // ...this.pixelInfo,
      };
      if (
        (this.UserLevelType === 0 && this.UserLevel === 0) ||
        this.UserLevelType > 1
      ) {
        obj.none.tip = "";
        obj.custom.tip = "";
        // obj['720p'].tip = '';
        // obj['1080p'].tip = '';
      } else {
        Promise.resolve(this.UserMsg)
          .then((data) => {
            let {
              nonWatermark,
              nonWatermarkRemain,
              updateWatermark,
              updateWatermarkRemain,
            } = data;
            let arr = [
              [obj.none, nonWatermark, nonWatermarkRemain, "去除水印"],
              [
                obj.custom,
                updateWatermark,
                updateWatermarkRemain,
                "自定义水印",
              ],
            ];
            arr.forEach((item) => {
              this.$set(item[0], "total", item[1]);
              this.$set(item[0], "remain", item[2]);
              // let tmpl = `您共有${item[1]}次${item[3]}的权益，目前还剩余${item[2]}次。`
              // let tmpl = `目前还剩余${item[2] > 999 ? '999+' : item[2]}次${item[3]}的权益。`
              let tmpl = `剩余${item[3]}次数: ${
                item[2] > 999 ? "999+" : item[2]
              }次`;
              if (item[2] > 999) {
                tmpl = "";
              }
              this.$set(item[0], "tip", tmpl);
            });
          })
          .catch(() => {});
      }

      this.setTipsPixel();

      this.updatePowerTip();
    },
    setTipsPixel() {
      let r = this.UserMsg.transformRemain;
      let info = this.pixelInfo;

      // if (this.isPersonVip) {
      //   // solo
      //   this.$set(info["720p"], "tip", `剩余高清画质导出次数: ${r}次`);
      // } else if (this.UserLevelType === 1 || this.UserLevelType === 2) {
      //   // 企业荣耀
      //   if (this.UserEquity.imgQuality === 720 && r <= 999) {
      //     this.$set(info["720p"], "tip", `剩余高清画质导出次数: ${r}次`);
      //   }
      //   // r === '999+' && this.$set(info["720p"], "tip", '');
      //   if (this.UserEquity.imgQuality === 1080 && r <= 999) {
      //     this.$set(info["1080p"], "tip", `剩余超清画质导出次数: ${r}次`);
      //   }
      // }
      let p = this.UserEquity.imgQuality;
      for (let item of Object.values(info)) {
        let pNum = +item.value;
        this.$set(info[item.value + "p"], "isVip", pNum > p);

        if (pNum === 720 && p === 720 && r <= 999) {
          this.$set(info["720p"], "tip", `剩余高清画质导出次数: ${r}次`);
        }
        if (pNum === 1080 && p === 1080 && r <= 999) {
          this.$set(info["1080p"], "tip", `剩余超清画质导出次数: ${r}次`);
        }
      }
    },
    // vip提示相关 end

    getBlobUrl(blob) {
      return window.URL.createObjectURL(blob || new Blob());
    },

    emitSaveWorks({
      covers,
      screen,
      isFirstFrameCover = false,
      onCompleted,
    } = {}) {
      this.sendInfoToEngine();
      // if (this.checkedWatermark.value != 'none' && this.checkedWatermark.value != 'default') {
      // }
      this.$bus.emit("topnav.saveWorks", {
        coverUrls: covers,
        screenParam: screen,
        isFirstFrameCover,
        onCompleted,
      });
    },

    onMyWatermarkLoaded(ev) {
      // let el = ev.target;
      // let { naturalHeight, naturalWidth } = el;
      // if (naturalHeight >= naturalWidth) {
      //   el.style.width = 'auto';
      //   el.style.height = '100%';
      // } else {
      //   el.style.width = '100%';
      //   el.style.height = 'auto';
      // }
    },

    getMovingHandler(dire) {
      if (this.TOOL.watermarkInfo && this.TOOL.watermarkInfo.url) {
        return this.getMovingHandlerByInfo();
      }
      let previewWidth = 493;
      let previewHeight = 278;

      if (dire === "v") {
        previewWidth = 155;
      }

      let w = previewWidth * 0.25;
      let h = (previewWidth * 0.25) / 2.5;

      this.watermarkInfo.defaults.w = w;
      this.watermarkInfo.defaults.h = h;

      return {
        x: previewWidth - (w * 1.2) / 2,
        y: previewHeight - (h * 1.2) / 2,
        w,
        h,
        aspectRatio: true,
        // selected: true,
        angle: 0,
        alwaysActive: false,
        isLimit: true,
        innerBound: {
          w: 12,
          h: 12,
        },
      };
    },

    getMovingHandlerByInfo() {
      let info = this.TOOL.watermarkInfo;
      let resolution = info.resolution - 0;
      let videoH = resolution;
      if (this.TOOL.optimized === "Vertical") {
        videoH = (resolution * 16) / 9;
      }
      const previewHeight = this.getPreviewHeight();
      let ratio = previewHeight / videoH;
      let gap = 0; // (PREVIEW_HEIGHT * 16 / 9 - PREVIEW_HEIGHT * 9 / 16) / 2;
      let x = info.x * ratio - gap;
      let y = info.y * ratio;
      let w = info.w * ratio;
      let h = info.h * ratio;
      return {
        x,
        y,
        w,
        h,
        aspectRatio: true,
        // selected: true,
        angle: info.angle,
        alwaysActive: false,
        isLimit: true,
        innerBound: {
          w: 12,
          h: 12,
        },
      };
    },

    getWatermarkPosition(resolution) {
      resolution = parseInt(resolution);
      let drr = this.$refs.drrHorizontal || {};
      let videoH = resolution;
      let gap = 0;
      if (this.TOOL.optimized === "Vertical") {
        drr = this.$refs.drrVertical || {};
        videoH = (resolution * 16) / 9;
        // gap = (videoH * 16 / 9 - videoH * 9 / 16) / 2;
      }
      // previewH / videoH = drr.rect.x / output.x
      const previewHeight = this.getPreviewHeight();
      let ratio = previewHeight / videoH;
      let names = ["x", "y", "w", "h"];
      let output = {
        resolution,
      };
      map(drr.rect, (v, k) => {
        if (names.indexOf(k) > -1) {
          output[k] = v / ratio;
          if (k === "x") {
            output[k] += gap;
          }
        } else {
          output[k] = v;
        }
      });
      // console.log({positionBefore: drr.rect, positionAfter: output})

      return output;
    },

    updateMovingHandler({ w, h } = {}) {
      let drr = this.$refs.drrHorizontal || {};
      if (this.TOOL.optimized === "Vertical") {
        drr = this.$refs.drrVertical || {};
      }

      if (!w || !h) {
        return;
      }

      drr.width = w;
      drr.height = h;

      this.$nextTick(() => {
        this.saveMovingHandlerSize({
          w,
          h,
          obj: this.checkedWatermark,
        });
      });
    },
    saveMovingHandlerSize({ w, h, obj = {} } = {}) {
      obj = obj || {};
      // obj.w = w;
      // obj.h = h;
      this.$set(obj, "w", w);
      this.$set(obj, "h", h);
    },
    getDrr() {
      let drr = this.$refs.drrHorizontal || {};
      if (this.TOOL.optimized === "Vertical") {
        drr = this.$refs.drrVertical || {};
      }

      return drr;
    },
    async setDrr(val) {
      let drr = this.$refs.drrHorizontal || {};
      if (this.TOOL.optimized === "Vertical") {
        drr = this.$refs.drrVertical || {};
      }

      let natural = await this.$util.getNaturalSize(val);
      // drr.h / natural.h = newW / natural.w

      const previewHeight = this.getPreviewHeight();
      drr.height = previewHeight * 0.25;
      drr.width = (drr.height / natural.h) * natural.w;
      drr.active = true;
    },
    getPreviewHeight() {
      const isVer = this.TOOL.optimized === "Vertical";
      let previewHeight = this.judgeBox ? PREVIEW_HEIGHT : PREVIEW_HEIGHT_SMALL;
      if (isVer && !this.judgeBox) {
        previewHeight = 245;
      }
      return previewHeight;
    },

    sendInfoToEngine() {
      const watermarkType = this.checkedWatermark.value;
      if (watermarkType === "default" || !watermarkType) {
        this.TOOL.watermarkInfo = false;
        return;
      }
      let watermarkPosition = this.getWatermarkPosition(
        this.checkedPixel.value
      );
      let watermarkInfo = {
        url: unhandleAssetsUrl(this.watermarkFile.url),
        ...watermarkPosition,
      };
      this.TOOL.watermarkInfo = watermarkInfo;
    },

    onDragStop() {
      this.$analysis("customized_watermark,drag_location,自定义水印_位置");
    },
    onResizeStop() {
      this.$analysis("customized_watermark,drag_scale，自定义水印_放缩");
    },
    onDrrActive() {
      this.sendInfoToEngine();
    },
    formDataFS(data) {
      this.formData[data.name] = data.data;
    },
    thisDataUpdata(name, data) {
      this[name] = data;
    },
    getLimit() {
      this.$http
        .get("/api/user/limit?type=work")
        .then((res) => {
          this.exportInfo = res.data.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    unlock() {
      this.isLock = false;
    },
    getShareState() {
      let dict = this.$util.localStorage.get("userShares");
      let val = (dict || {})[this.UserMsg.id + ""] || "on";
      return !!(val === "on");
    },
    setShareState(val) {
      let dict = this.$util.localStorage.get("userShares");
      if (!dict) {
        dict = {};
      }
      dict[this.UserMsg.id] = val;
      this.$util.localStorage.set("userShares", dict);
    },
    onClickCoverOption() {
      if (this.firstFrameCoverDisabled) {
        this.$modal.show("vipDialog", {
          msg: "升级个人会员，解锁视频合成封面技能",
          target: "vipsolo",
          type: "solo",
        });
      }
    },
    getTagsPlaceholder(max) {
      return `填写标签便于检索，最多不超过${max}个，点击Enter隔开多个标签`;
    },
    updatePowerTip() {
      if (this.$refs.powerTip) {
        this.$refs.powerTip.init();
      }
    },
    /** 展示审核详情 */
    showCensoredInfo() {
      this.$modal.show('censoredInfo', {data: this.coverForbiddenState.info});
    },
    async coverAudit(url) {
      if (!url) return;
      url = url.indexOf('?t=') !== -1 ? url.substring(0, url.indexOf('?t=')) : url;

      const resp = await this.$http.get('/api/forbidden/info', {
        params: {
          url: this.$handleAssetsUrl(url)
        }
      })
      const data = (resp.data || {}).data;

      this.$store.commit("set_coverForbiddenAudit", {
        url: `${url}?t=${+new Date()}`,
        state: !data ? 3 : 0,
        info: data
      });
    },
    async refreshForbiddenState() {
      const { url } = this.coverForbiddenState;
      if (!url) return;

      this.$store.commit("set_coverForbiddenAudit", {
        state: 2,
        info: null
      });

      await this.coverAudit(url);
    },
    getWatermarkBadgeClassName (key) {
      console.log(`Turbo ~ getWatermarkBadgeClassName ~ key:`, key)
      if (['none', 'custom'].includes(key)) {
        return this.getBadgeClassName();
      }
    },
    getBadgeClassName () {
      const fromType = this.UserMsg.levelType || 0;
      const toType = fromType + 1;
      const map = new Map([
        [1, 'vip-logo'],
        [2, 'pro-logo'],
        [3, 'proPlus-logo']
      ]);
      return map.get(toType);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/colors";
@import "./exportDialog";
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: $c10;
}
.md40 {
  margin-bottom: 40px;
}
.md22 {
  margin-bottom: 22px;
}
.md20 {
  margin-bottom: 20px;
}
.md10 {
  margin-bottom: 10px;
}
.dialog {
  &__close {
    position: absolute;
    // 从平台的样式复制粘贴 start
    position: absolute;
    top: 50px;
    right: 100px;
    left: 120%;
    display: flex;
    justify-content: center;
    align-items: center;
    // position: absolute;
    // top: 0;
    // right: 0;
    width: 36px;
    height: 36px;
    background: url(../../../static/svg/cross.svg);
    background-size: contain;
    border-radius: 4px;
    cursor: pointer;
    cursor: pointer;

    &:hover {
      background: url(../../../static/svg/cross.svg);
      background-size: contain;
      opacity: 0.6;
    }
    // 从平台的样式复制粘贴 end

    > i {
      width: 50px;
      height: 50px;
    }
  }
  &__header {
    position: relative;
    max-width: 500px;
    height: 40px;
    margin: auto;
    line-height: 40px;
  }
  &__body {
    padding-top: 58px;
    padding-right: 114px;
    padding-left: 100px;
  }
  &__footer {
    padding-top: 50px;
    padding-bottom: 110px;
  }
}

/deep/ .form-field {
  display: flex;
  justify-content: center;
  align-items: center;

  &__title {
    position: relative;
    white-space: nowrap;
    width: 60px;
    text-align: right;
    &.is-top {
      margin-top: -38px;
    }
    &.is-required {
      &:before {
        content: " ";
        position: absolute;
        top: -0.2em;
        right: -0.6em;
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 8px;
        transform: scale(0.6);
      }
    }
  }
  &__content {
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 527px;
    margin-left: 28px;
  }
  &__tag {
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 1em;
    margin-right: 8px;
    color: $c0;
    line-height: 40px;
    background-color: $c2;
    border-radius: 4px;
    transition-duration: 0.3s;

    > span {
      white-space: nowrap;
    }

    > .remove {
      display: inline-block;
      width: 1em;
      height: 1em;
      transform: translate(0.5em, 0);
    }
  }
  &__input {
    position: relative;
    width: 527px;
    height: 40px;
    background-color: $c9;
    border-radius: 4px;
    transition-duration: 0.3s;
    background: #f8f8fc;
    border: 1px solid #ddd9eb;

    > input {
      width: 100%;
      height: 100%;
      padding-right: 1em;
      padding-left: 1em;
      background-color: transparent;
      border: none;
    }
  }
  &__textarea {
    position: relative;
    width: 527px;
    height: 80px;
    background-color: $c9;
    border-radius: 4px;
    background: #f8f8fc;
    border: 1px solid #ddd9eb;
    > textarea {
      width: 100%;
      height: 100%;
      padding: 1em;
      background: transparent;
      border: none;
      resize: none;
    }
  }
  &__tip {
    position: absolute;
    right: 1em;
    bottom: 0.6em;
    color: $c10;
  }
  &__valid-tip {
    position: absolute;
    bottom: -17px;
    left: 1em;
    color: red;
    font-size: 12px;
  }
}

.form {
  &__cover-preview {
    $preview-box-width: 493px;
    $preview-box-width-2: 155px;
    $preview-box-height: 278px;
    position: relative;
    overflow: hidden;
    width: $preview-box-width;
    height: $preview-box-height;
    margin-right: auto;
    margin-left: auto;
    border: solid 1px $c6;
    transform: translatex(11px);

    > img {
      height: 100%;
    }

    > .watermark {
      position: absolute;
      right: 0; // $preview-box-width * 0.02;
      bottom: 0; // $preview-box-height * 0.02;
      width: 493px; // $preview-box-width * 0.6;
      height: 278px; // $preview-box-width * 0.6 * 927 / 1157;
      &.small {
        width: 294px;
        height: 165px;
      }
      &.small.vertical-editor {
        width: 138px;
        height: 245px;
      }

      &.vertical-editor {
        right: 0; // 6px;
        bottom: 0; // 29px;
        width: 155px; // 155px * 0.9;
        height: 278px; // 155px * 0.9 * 927 / 1157;
      }
      & > img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
      }
    }

    > .watermark--default {
      > i {
        position: absolute;
        right: 0;
        bottom: 0;
        // width: $preview-box-width * 0.13;
        // height: $preview-box-width * 0.13 * 58 / 103;
        width: $preview-box-width * 0.25;
        // height: $preview-box-width * 0.25 / 2.5;
        height: $preview-box-width * 0.25 * 927 / 1157;

        &.vertical-editor {
          width: $preview-box-width-2 * 0.25;
          // height: $preview-box-width-2 * 0.25 / 2.5;
          height: $preview-box-width-2 * 0.25;
        }
      }
    }

    > .watermark--default-small {
      > i {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 294px * 0.25;
        height: 294px * 0.25 * 927 / 1157;

        &.vertical-editor {
          width: 138px * 0.25;
          height: 138px * 0.25;
        }
      }
    }

    > .btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
      width: 60px;
      height: 30px;
      color: $c3;
      line-height: 30px;
      text-align: center;
      background-color: $c0;
      box-shadow: 0 0 3px 0 rgba($c3, 0.3);
      border: 1px solid $c3;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        color: $c2;
        border-color: $c2;
      }
    }
  }
}

.painterSubmit {
  display: flex;
  justify-content: center;
}

.cover-picker {
  width: 527px;
  > ul {
    display: flex;
    align-items: center;
    > li {
      box-sizing: border-box;
      width: 100px;
      height: 57px;
      margin-right: 8px;
      border: 1px solid $c6;

      > img {
        height: 100%;

        &.is-selected {
          box-shadow: 0 0 0 2px $c2;
        }
      }

      &.is-selected {
        box-shadow: 0 0 0 1px $c2;
        border: 1px solid $c2;
      }

      &.is-add {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 70px;
        height: 50px;
        margin-left: 24px;
        background-color: $c9;
        border-radius: 4px;
        cursor: pointer;
        > .my-icon-add {
          position: relative;
          display: inline-block;
          width: 18px;
          height: 18px;
          color: $c2;
          &:before {
            content: " ";
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 2px;
            margin-top: -1px;
            background-color: $c2;
          }

          &:after {
            content: " ";
            position: absolute;
            top: 0;
            left: 50%;
            width: 2px;
            height: 100%;
            margin-left: -1px;
            background-color: $c2;
          }
        }
        > .el-icon-edit {
          &:before {
            color: $c2;
          }
        }
      }
    }
  }
}

.radios {
  > ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > li {
      position: relative;
      width: 200px;
      &:last-child {
        width: 250px;
      }
    }
  }
}
.radio {
  display: inline-block;
  display: flex;
  align-items: center;
  cursor: pointer;

  &__shape {
    // display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border: 2px solid $c2;
    border-radius: 16px;

    &.is-active {
      background-color: $c2;
      box-shadow: 0 0 0 2px $c0 inset;
    }

    // &.is-active {
    //   &:before {
    //     content: ' ';
    //     // display: flex;
    //     display: block;
    //     box-sizing: border-box;
    //     width: 12px;
    //     height: 12px;
    //     border-radius: 12px;
    //     background-color: $c2;
    //     box-shadow: 0 0 0 2px $c0 inset;
    //   }
    // }
  }
  &__label {
    display: flex;
    margin-left: 1.2em;
    white-space: nowrap;
  }
  &__tip {
    position: absolute;
    bottom: 0;
    left: 0;
    color: $c2;
    white-space: nowrap;
    transform: translatey(150%);
  }
}

.submit {
  width: 160px;
  height: 40px;
  margin: auto;
  color: $c0;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}

.mark-old {
  box-sizing: border-box;
  min-width: 30px;
  height: 18px;
  padding: 0 4px;
  margin-left: 8px;
  color: $c0;
  font-size: 12px;
  line-height: 18px;
  background-color: $c11;
  border-radius: 4px;
}

// .commonVip {
//   width: 36px;
//   height: 16px;
//   margin-left: 8px;
//   background-image: url(../../../static/svg/payTypeSubscript/commonVip.svg);
//   background-repeat: no-repeat;
//   background-size: cover;
// }
// .companyVip {
//   width: 50px;
//   height: 16px;
//   margin-left: 8px;
//   content: url(../../../static/svg/payTypeSubscript/companyVip50x16.svg);
// }
.companyVip, .commonVip {
  width: 50px;
  height: 16px;
  margin-left: 8px;
  content: url(../../../static/svg/payTypeSubscript/companyVip50x16.svg);
}
.vip-logo {
  width: 36px;
  height: 16px;
  margin-left: 8px;
  content: url(../../../static/svg/payTypeSubscript/commonVip.svg);
}
.pro-logo {
  width: 30px;
  height: 18px;
  margin-left: 8px;
  content: url(../../assets/pro.png);
}
.proPlus-logo {
  width: 30px;
  height: 18px;
  margin-left: 8px;
  content: url(../../assets/proPlus.png);
}
.mark {
  box-sizing: content-box;
  width: 38px !important;
  height: 14px;
  margin-left: 8px;
  color: #f9d8a4;
  font-size: 12px;
  font-weight: bold;
  line-height: 14px;
  background-image: linear-gradient(108deg, #36332f 0%, #12100a 100%);
  border: solid 1px #fff;
  border-radius: 7px;

  &.basic {
    color: #fff;
    background-image: linear-gradient(-62deg, #c29484 0%, #f1d9c9 100%);
  }
}

.small-btn {
  display: inline-block;
  width: 3em;
  height: 1.5em;
  line-height: 1.5em;
  border-radius: 4px;
}
.ml {
  margin-left: 1em;
}
.dialog__header {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  max-width: 1200px;
  border-bottom: 1px solid rgb(234, 234, 244);
  .dialog__close {
    right: 0;
    left: 97%;
  }
}

.text-blue {
  color: #5778fb;
}

.cover-option {
  position: relative;
  display: flex;
  align-items: center;
  width: 120px;
  height: 30px;
}

.cover-forbidden-state {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  > div {
    color: #fff;
  }

  > div::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .loading::after {
    content: url(../../assets/exportDialog/loading.svg);
    position: absolute;
    top: 57px;
    left: 50%;
    margin-left: -12px;
    z-index: 1;
    width: 24px;
    height: 24px;
    animation: rotate linear 1.6s infinite;
  }

  .loading {
    padding-top: 92px;

    p {
      position: relative;
    }
  }

  .oper-btn {
    display: flex;
    justify-content: center;
    margin-top: 12px;

    > button {
      width: 60px;
      height: 24px;
      line-height: 24px;
      opacity: 0.9;
      border-radius: 4px;
      font-size: 12px;
      margin: 0 8px;
      position: relative;
      border: none;
      cursor: pointer;
      transition: background 0.2s linear;
    }

    .button--default:hover{
      background-color: #d9d9d9;
    }

    &.oper-btn-Vertical {
      display: flex;
      justify-content: space-between;
      padding: 0 4px;

      > button {
        margin: 0;
      }
    }
  }

  .cover-failed {
    text-align: center;
    padding-top: 73px;

    p {
      position: relative;

      a {
        color: #ffff;
      }
    }
  }

  .cover-failed::after {
    content: url(../../assets/exportDialog/warning.svg);
    position: absolute;
    top: 39px;
    left: 50%;
    margin-left: -12px;
    z-index: 1;
    width: 24px;
    height: 24px;
  }

}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style>
.v--modal-overlay[data-modal=censoredInfo] {
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog.vue